export const filterRules = {
  CURRENT: [
    {
      "Part #": "FAB201775",
      "Fabric Name/Color": "Abigail Cotton",
      Grade: "Basic",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Jaquard",
      "Color Category": "Whites & Neutrals",
    },
    {
      "Part #": "FAB201187",
      "Fabric Name/Color": "BELMONT SKY",
      Grade: "Basic",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Woven Texture",
      "Color Category": "Blues",
    },
    {
      "Part #": "FAB200512",
      "Fabric Name/Color": "Acdc Natural",
      Grade: "Accent/Pillow",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Pattern",
      "Material Type": "Woven Texture",
      "Color Category": "Whites & Neutrals",
    },
    {
      "Part #": "FAB201850",
      "Fabric Name/Color": "Adelaide Cream",
      Grade: "Basic",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Woven Texture",
      "Color Category": "Whites & Neutrals",
    },
    {
      "Part #": "FAB201849",
      "Fabric Name/Color": "Adelaide Twine",
      Grade: "Basic",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Woven Texture",
      "Color Category": "Greys & Charcoal",
    },
    {
      "Part #": "FAB200123",
      "Fabric Name/Color": "Agler Melon",
      Grade: "Accent/Pillow",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Pattern",
      "Material Type": "Jacquard",
      "Color Category": "Pink, Red, & Orange",
    },
    {
      "Part #": "FAB201287",
      "Fabric Name/Color": "Aldous Honey",
      Grade: "Accent/Pillow",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Pattern",
      "Material Type": "Jaquard",
      "Color Category": "Browns",
    },
    {
      "Part #": "FAB201486",
      "Fabric Name/Color": "Amici Denim",
      Grade: "Basic",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Chenille",
      "Color Category": "Blues",
    },
    {
      "Part #": "FAB201233",
      "Fabric Name/Color": "Amici Ginger",
      Grade: "Basic",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Chenille",
      "Color Category": "Pink, Red, & Orange",
    },
    {
      "Part #": "FAB201235",
      "Fabric Name/Color": "Amici Indigo",
      Grade: "Basic",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Chenille",
      "Color Category": "Greens & Yellows",
    },
    {
      "Part #": "FAB201232",
      "Fabric Name/Color": "Amici Moss",
      Grade: "Basic",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Chenille",
      "Color Category": "Blues",
    },
    {
      "Part #": "FAB201485",
      "Fabric Name/Color": "Amici Oyster",
      Grade: "Basic",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Chenille",
      "Color Category": "Greys & Charcoals",
    },
    {
      "Part #": "FAB201234",
      "Fabric Name/Color": "Amici Sand",
      Grade: "Basic",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Chenille",
      "Color Category": "Whites & Neutrals",
    },
    {
      "Part #": "FAB201236",
      "Fabric Name/Color": "Amici Smoke",
      Grade: "Basic",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Chenille",
      "Color Category": "Greys & Charcoal",
    },
    {
      "Part #": "FAB201843",
      "Fabric Name/Color": "Amiri Ochre",
      Grade: "Accent/Pillow",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Pattern",
      "Material Type": "Print",
      "Color Category": "Pinks, Reds, Oranges",
    },
    {
      "Part #": "FAB201864",
      "Fabric Name/Color": "Andrew Amaryllis",
      Grade: "Basic",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Woven Texture",
      "Color Category": "Pinks, Reds, Oranges",
    },
    {
      "Part #": "FAB201863",
      "Fabric Name/Color": "Andrew Cognac",
      Grade: "Basic",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Woven Texture",
      "Color Category": "Browns",
    },
    {
      "Part #": "FAB201869",
      "Fabric Name/Color": "Andrew Cream",
      Grade: "Basic",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Woven Texture",
      "Color Category": "Whites & Neutrals",
    },
    {
      "Part #": "FAB201870",
      "Fabric Name/Color": "",
      Grade: "",
      "JL Upholstery": "",
      "Solid or Pattern": "",
      "Material Type": "",
      "Color Category": "",
    },
    {
      "Part #": "FAB101036",
      "Fabric Name/Color": "Angel Pewter",
      Grade: "Basic",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Woven Texture",
      "Color Category": "Blacks & Purples",
    },
    {
      "Part #": "FAB201948",
      "Fabric Name/Color": "Ansley Aloe",
      Grade: "Basic",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Pattern",
      "Material Type": "Woven Texture",
      "Color Category": "Blues",
    },
    {
      "Part #": "FAB201834",
      "Fabric Name/Color": "Ansley Pearl",
      Grade: "Basic",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Pattern",
      "Material Type": "Woven Texture",
      "Color Category": "Whites & Neutrals",
    },
    {
      "Part #": "FAB201226",
      "Fabric Name/Color": "Anya Adobe",
      Grade: "Accent/Pillow",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Pattern",
      "Material Type": "Chenille",
      "Color Category": "Pinks, Reds, Oranges",
    },
    {
      "Part #": "FAB201793",
      "Fabric Name/Color": "Apollo Alabaster",
      Grade: "Basic",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Chenille",
      "Color Category": "Whites & Neutrals",
    },
    {
      "Part #": "FAB201794",
      "Fabric Name/Color": "Apollo Platinum",
      Grade: "Basic",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Chenille",
      "Color Category": "Whites & Neutrals",
    },
    {
      "Part #": "FAB201791",
      "Fabric Name/Color": "Apollo Sand",
      Grade: "Basic",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Chenille",
      "Color Category": "Whites & Neutrals",
    },
    {
      "Part #": "FAB101041",
      "Fabric Name/Color": "Aquiline Pewter",
      Grade: "Accent/Pillow",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Pattern",
      "Material Type": "Canvas/Cotton",
      "Color Category": "Greys & Charcoal",
    },
    {
      "Part #": "FAB200046",
      "Fabric Name/Color": "Aquinto Canyon",
      Grade: "Accent/Pillow",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Pattern",
      "Material Type": "Jacquard",
      "Color Category": "Pink, Red, & Orange",
    },
    {
      "Part #": "FAB201242",
      "Fabric Name/Color": "Artisan Barley",
      Grade: "Basic",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Linen Look",
      "Color Category": "Whites & Neutrals",
    },
    {
      "Part #": "FAB201243",
      "Fabric Name/Color": "Artisan Praline",
      Grade: "Basic",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Linen Look",
      "Color Category": "Browns",
    },
    {
      "Part #": "FAB201244",
      "Fabric Name/Color": "Artisan Sage",
      Grade: "Basic",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Linen Look",
      "Color Category": "Greens & Yellows",
    },
    {
      "Part #": "FAB201727",
      "Fabric Name/Color": "Ascari Acuna",
      Grade: "Accent/Pillow",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Pattern",
      "Material Type": "Woven Texture",
      "Color Category": "Browns",
    },
    {
      "Part #": "FAB201835",
      "Fabric Name/Color": "Asha Twine",
      Grade: "Accent/Pillow",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Pattern",
      "Material Type": "Jaquard",
      "Color Category": "Whites & Neutrals",
    },
    {
      "Part #": "FAB201844",
      "Fabric Name/Color": "Ashanti Claret",
      Grade: "Accent/Pillow",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Pattern",
      "Material Type": "Jaquard",
      "Color Category": "Blacks & Purples",
    },
    {
      "Part #": "FAB201195",
      "Fabric Name/Color": "Aspen Charcoal",
      Grade: "Basic",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Faux Fur",
      "Color Category": "Greys & Charcoal",
    },
    {
      "Part #": "FAB200942",
      "Fabric Name/Color": "Aston Saphire",
      Grade: "Basic",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Velvet",
      "Color Category": "Browns",
    },
    {
      "Part #": "FAB201205",
      "Fabric Name/Color": "Aston Truffle",
      Grade: "Basic",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Print",
      "Color Category": "Greys & Charcoal",
    },
    {
      "Part #": "FAB201206",
      "Fabric Name/Color": "Aston Whisper",
      Grade: "Basic",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Print",
      "Color Category": "Greys & Charcoal",
    },
    {
      "Part #": "FAB101051",
      "Fabric Name/Color": "Awesome Denim",
      Grade: "Accent/Pillow",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Pattern",
      "Material Type": "Woven Texture",
      "Color Category": "Blues",
    },
    {
      "Part #": "FAB101053",
      "Fabric Name/Color": "Awesome Haven",
      Grade: "Accent/Pillow",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Pattern",
      "Material Type": "Woven Texture",
      "Color Category": "Blues",
    },
    {
      "Part #": "FAB101054",
      "Fabric Name/Color": "Awesome Sunset",
      Grade: "Accent/Pillow",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Pattern",
      "Material Type": "Woven Texture",
      "Color Category": "Pink, Red, & Orange",
    },
    {
      "Part #": "FAB201859",
      "Fabric Name/Color": "Azalea Heritage",
      Grade: "Accent/Pillow",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Pattern",
      "Material Type": "Print",
      "Color Category": "Whites & Neutrals",
    },
    {
      "Part #": "FAB101056",
      "Fabric Name/Color": "Azera Onyx",
      Grade: "Accent/Pillow",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Pattern",
      "Material Type": "Jacquard",
      "Color Category": "Blacks & Purples",
    },
    {
      "Part #": "FAB201305",
      "Fabric Name/Color": "Bamford Clay",
      Grade: "Accent/Pillow",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Pattern",
      "Material Type": "Jacquard",
      "Color Category": "Pink, Red, & Orange",
    },
    {
      "Part #": "FAB201017",
      "Fabric Name/Color": "Bamford Tuxedo",
      Grade: "Accent/Pillow",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Pattern",
      "Material Type": "Jacquard",
      "Color Category": "Blacks & Purples",
    },
    {
      "Part #": "FAB201788",
      "Fabric Name/Color": "Barat Fawn",
      Grade: "Accent/Pillow",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Faux Fur",
      "Color Category": "Browns",
    },
    {
      "Part #": "FAB201831",
      "Fabric Name/Color": "Bardugo Twine",
      Grade: "Accent/Pillow",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Pattern",
      "Material Type": "Jaquard",
      "Color Category": "Whites & Neutrals",
    },
    {
      "Part #": "FAB201746",
      "Fabric Name/Color": "Battini Brindle",
      Grade: "Accent",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Pattern",
      "Material Type": "Woven Texture",
      "Color Category": "Blacks & Purples",
    },
    {
      "Part #": "FAB101086",
      "Fabric Name/Color": "Bella Asphalt",
      Grade: "Basic",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Velvet",
      "Color Category": "Greys & Charcoal",
    },
    {
      "Part #": "FAB101087",
      "Fabric Name/Color": "Bella Aubergine",
      Grade: "Basic",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Velvet",
      "Color Category": "Blacks & Purples",
    },
    {
      "Part #": "FAB101088",
      "Fabric Name/Color": "Bella Beach",
      Grade: "Basic",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Velvet",
      "Color Category": "Whites & Neutrals",
    },
    {
      "Part #": "FAB101090",
      "Fabric Name/Color": "Bella Black",
      Grade: "Basic",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Velvet",
      "Color Category": "Blacks & Purples",
    },
    {
      "Part #": "FAB101092",
      "Fabric Name/Color": "Bella Buckwheat",
      Grade: "Basic",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Velvet",
      "Color Category": "Whites & Neutrals",
    },
    {
      "Part #": "FAB101094",
      "Fabric Name/Color": "Bella Chocolate",
      Grade: "Basic",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Velvet",
      "Color Category": "Browns",
    },
    {
      "Part #": "FAB101097",
      "Fabric Name/Color": "Bella Cornflower",
      Grade: "Basic",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Velvet",
      "Color Category": "Blues",
    },
    {
      "Part #": "FAB101098",
      "Fabric Name/Color": "Bella Dove",
      Grade: "Basic",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Velvet",
      "Color Category": "Greys & Charcoal",
    },
    {
      "Part #": "FAB101101",
      "Fabric Name/Color": "Bella Grey",
      Grade: "Basic",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Velvet",
      "Color Category": "Greys & Charcoal",
    },
    {
      "Part #": "FAB101103",
      "Fabric Name/Color": "Bella Ink",
      Grade: "Basic",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Velvet",
      "Color Category": "Blues",
    },
    {
      "Part #": "FAB101105",
      "Fabric Name/Color": "Bella Lagoon",
      Grade: "Basic",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Velvet",
      "Color Category": "Blues",
    },
    {
      "Part #": "FAB101110",
      "Fabric Name/Color": "Bella Pearl",
      Grade: "Basic",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Velvet",
      "Color Category": "Pink, Red, & Orange",
    },
    {
      "Part #": "FAB101116",
      "Fabric Name/Color": "Bella Toast",
      Grade: "Basic",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Velvet",
      "Color Category": "Whites & Neutrals",
    },
    {
      "Part #": "FAB101117",
      "Fabric Name/Color": "Bella Vintage",
      Grade: "Basic",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Velvet",
      "Color Category": "Greys & Charcoal",
    },
    {
      "Part #": "FAB201787",
      "Fabric Name/Color": "Bellamy Oasis",
      Grade: "Accent/Pillow",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Pattern",
      "Material Type": "Jaquard",
      "Color Category": "Blues",
    },
    {
      "Part #": "FAB201185",
      "Fabric Name/Color": "Belmont Clay",
      Grade: "Basic",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Woven Texture",
      "Color Category": "Pinks, Reds, Oranges",
    },
    {
      "Part #": "FAB201186",
      "Fabric Name/Color": "Belmont Jade",
      Grade: "Basic",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Woven Texture",
      "Color Category": "Greens & Yellows",
    },
    {
      "Part #": "FAB201184",
      "Fabric Name/Color": "Belmont Mink",
      Grade: "Basic",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Woven Texture",
      "Color Category": "Browns",
    },
    {
      "Part #": "FAB201207",
      "Fabric Name/Color": "Belmont Platinum",
      Grade: "Basic",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Woven Texture",
      "Color Category": "Greys & Charcoals",
    },
    {
      "Part #": "FAB101123",
      "Fabric Name/Color": "Bennett Indigo",
      Grade: "Basic",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Linen Look",
      "Color Category": "Blues",
    },
    {
      "Part #": "FAB201457",
      "Fabric Name/Color": "Bianca Maize",
      Grade: "Basic",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Velvet",
      "Color Category": "Greens & Yellows",
    },
    {
      "Part #": "FAB201458",
      "Fabric Name/Color": "Bianca Moss",
      Grade: "Basic",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Velvet",
      "Color Category": "Greens & Yellows",
    },
    {
      "Part #": "FAB201460",
      "Fabric Name/Color": "Bianca Prussian",
      Grade: "Basic",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Velvet",
      "Color Category": "Blues",
    },
    {
      "Part #": "FAB201483",
      "Fabric Name/Color": "Bianca Rosewood",
      Grade: "Basic",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Chenille",
      "Color Category": "Pink, Red, & Orange",
    },
    {
      "Part #": "FAB201459",
      "Fabric Name/Color": "Bianca Willow",
      Grade: "Basic",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Velvet",
      "Color Category": "Greens & Yellows",
    },
    {
      "Part #": "FAB101141",
      "Fabric Name/Color": "Bippy Bop",
      Grade: "Accent/Pillow",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Pattern",
      "Material Type": "Jacquard",
      "Color Category": "Pink, Red, & Orange",
    },
    {
      "Part #": "FAB201801",
      "Fabric Name/Color": "Bobbi Desert",
      Grade: "Basic",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Chenille",
      "Color Category": "Whites & Neutrals",
    },
    {
      "Part #": "FAB201776",
      "Fabric Name/Color": "Bobbi Jean",
      Grade: "Basic",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Jaquard",
      "Color Category": "Blues",
    },
    {
      "Part #": "FAB201795",
      "Fabric Name/Color": "Bobbi Thyme",
      Grade: "Basic",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Chenille",
      "Color Category": "Greens & Yellows",
    },
    {
      "Part #": "FAB200134",
      "Fabric Name/Color": "Bocci Mineral",
      Grade: "Accent/Pillow",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Pattern",
      "Material Type": "Woven Texture",
      "Color Category": "Browns",
    },
    {
      "Part #": "FAB201247",
      "Fabric Name/Color": "Bonelli Mineral",
      Grade: "Accent/Pillow",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Pattern",
      "Material Type": "Chenille",
      "Color Category": "Whites & Neutrals",
    },
    {
      "Part #": "FAB201328",
      "Fabric Name/Color": "Bonnie Meadow",
      Grade: "Accent/Pillow",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Pattern",
      "Material Type": "Jaquard",
      "Color Category": "Greens & Yellows",
    },
    {
      "Part #": "FAB201346",
      "Fabric Name/Color": "Brazza Dove",
      Grade: "Basic",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Woven Texture",
      "Color Category": "Whites & Neutrals",
    },
    {
      "Part #": "FAB201012",
      "Fabric Name/Color": "Bridger Seaspray",
      Grade: "Basic",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Canvas/Cotton",
      "Color Category": "Blues",
    },
    {
      "Part #": "LEA100034",
      "Fabric Name/Color": "Brighton Black",
      Grade: "Top Grain Leather",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Leather",
      "Color Category": "Blacks & Purples",
    },
    {
      "Part #": "LEA100035",
      "Fabric Name/Color": "Brighton Cedar Grove",
      Grade: "Top Grain Leather",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Leather",
      "Color Category": "Blues",
    },
    {
      "Part #": "LEA100091",
      "Fabric Name/Color": "Brighton Dark Pine",
      Grade: "Top Grain Leather",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Leather",
      "Color Category": "Browns",
    },
    {
      "Part #": "LEA100036",
      "Fabric Name/Color": "Brighton Dune",
      Grade: "Top Grain Leather",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Leather",
      "Color Category": "Browns",
    },
    {
      "Part #": "LEA100037",
      "Fabric Name/Color": "Brighton Everglade",
      Grade: "Top Grain Leather",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Leather",
      "Color Category": "Greens & Yellows",
    },
    {
      "Part #": "LEA100038",
      "Fabric Name/Color": "Brighton Hero",
      Grade: "Top Grain Leather",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Leather",
      "Color Category": "Browns",
    },
    {
      "Part #": "LEA100039",
      "Fabric Name/Color": "Brighton Lagoon",
      Grade: "Top Grain Leather",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Leather",
      "Color Category": "Blues",
    },
    {
      "Part #": "LEA100040",
      "Fabric Name/Color": "Brighton Linen",
      Grade: "Top Grain Leather",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Leather",
      "Color Category": "Whites & Neutrals",
    },
    {
      "Part #": "LEA100032",
      "Fabric Name/Color": "Brighton Loden",
      Grade: "Top Grain Leather",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Leather",
      "Color Category": "Greens & Yellows",
    },
    {
      "Part #": "LEA100042",
      "Fabric Name/Color": "Brighton Mink",
      Grade: "Top Grain Leather",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Leather",
      "Color Category": "Browns",
    },
    {
      "Part #": "LEA100043",
      "Fabric Name/Color": "Brighton Pewter",
      Grade: "Top Grain Leather",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Leather",
      "Color Category": "Greys & Charcoal",
    },
    {
      "Part #": "FAB101105",
      "Fabric Name/Color": "Brighton Putty",
      Grade: "Top Grain Leather",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Velvet",
      "Color Category": "Blues",
    },
    {
      "Part #": "LEA100044",
      "Fabric Name/Color": "Brighton Red Clay",
      Grade: "Top Grain Leather",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Leather",
      "Color Category": "Pink, Red, & Orange",
    },
    {
      "Part #": "LEA100045",
      "Fabric Name/Color": "Brighton Shadow",
      Grade: "Top Grain Leather",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Leather",
      "Color Category": "Greys & Charcoal",
    },
    {
      "Part #": "LEA100046",
      "Fabric Name/Color": "Brompton Blue & Black",
      Grade: "Top Grain Leather",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Leather",
      "Color Category": "Blues",
    },
    {
      "Part #": "FAB201743",
      "Fabric Name/Color": "Brynn Zinc",
      Grade: "Accent",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Pattern",
      "Material Type": "Jacquard",
      "Color Category": "Greys & Charcoal",
    },
    {
      "Part #": "FAB201729",
      "Fabric Name/Color": "Buffalo Haze",
      Grade: "Accent/Pillow",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Pattern",
      "Material Type": "Woven Texture",
      "Color Category": "Greys & Charcoals",
    },
    {
      "Part #": "FAB201833",
      "Fabric Name/Color": "Bukhara Fresca",
      Grade: "Accent/Pillow",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Pattern",
      "Material Type": "Woven Texture",
      "Color Category": "Whites & Neutrals",
    },
    {
      "Part #": "FAB201487",
      "Fabric Name/Color": "Bungalow Ash",
      Grade: "Basic",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Chenille",
      "Color Category": "Greys & Charcoals",
    },
    {
      "Part #": "FAB201013",
      "Fabric Name/Color": "Bungalow Eclipse",
      Grade: "Basic",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Chenille",
      "Color Category": "Blues",
    },
    {
      "Part #": "FAB201014",
      "Fabric Name/Color": "Bungalow Graphite",
      Grade: "Basic",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Chenille",
      "Color Category": "Greys & Charcoal",
    },
    {
      "Part #": "FAB200996",
      "Fabric Name/Color": "Bungalow Mocha",
      Grade: "Basic",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Chenille",
      "Color Category": "Browns",
    },
    {
      "Part #": "FAB200949",
      "Fabric Name/Color": "Bungalow Snow",
      Grade: "Basic",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Chenille",
      "Color Category": "Whites & Neutrals",
    },
    {
      "Part #": "FAB201304",
      "Fabric Name/Color": "Caleb Copper",
      Grade: "Accent/Pillow",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Pattern",
      "Material Type": "Woven Texture",
      "Color Category": "Pink, Red, & Orange",
    },
    {
      "Part #": "FAB201239",
      "Fabric Name/Color": "Camila Dove",
      Grade: "Basic",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Chenille",
      "Color Category": "Whites & Neutrals",
    },
    {
      "Part #": "FAB201240",
      "Fabric Name/Color": "Camila Mocha",
      Grade: "Basic",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Chenille",
      "Color Category": "Browns",
    },
    {
      "Part #": "FAB201309",
      "Fabric Name/Color": "Camila Olive",
      Grade: "Basic",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Chenille",
      "Color Category": "Greens & Yellows",
    },
    {
      "Part #": "FAB201293",
      "Fabric Name/Color": "Camila Oyster",
      Grade: "Basic",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Chenille",
      "Color Category": "Whites & Neutrals",
    },
    {
      "Part #": "FAB201303",
      "Fabric Name/Color": "Camila Sand",
      Grade: "Basic",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Chenille",
      "Color Category": "Whites & Neutrals",
    },
    {
      "Part #": "FAB201241",
      "Fabric Name/Color": "Camila Steel",
      Grade: "Basic",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Chenille",
      "Color Category": "Greys & Charcoal",
    },
    {
      "Part #": "FAB201471",
      "Fabric Name/Color": "Canyon Putty",
      Grade: "Accent/Pillow",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Pattern",
      "Material Type": "Woven Texture",
      "Color Category": "Whites & Neutrals",
    },
    {
      "Part #": "FAB101268",
      "Fabric Name/Color": "Caprice Cerulean",
      Grade: "Basic",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Woven Texture",
      "Color Category": "Blues",
    },
    {
      "Part #": "FAB101269",
      "Fabric Name/Color": "Caprice Charcoal",
      Grade: "Basic",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Woven Texture",
      "Color Category": "Greys & Charcoal",
    },
    {
      "Part #": "FAB101273",
      "Fabric Name/Color": "Caprice Granite",
      Grade: "Basic",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Woven Texture",
      "Color Category": "Browns",
    },
    {
      "Part #": "FAB101274",
      "Fabric Name/Color": "Caprice Hemp",
      Grade: "Basic",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Woven Texture",
      "Color Category": "Whites & Neutrals",
    },
    {
      "Part #": "FAB101275",
      "Fabric Name/Color": "Caprice Java",
      Grade: "Basic",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Woven Texture",
      "Color Category": "Browns",
    },
    {
      "Part #": "FAB101276",
      "Fabric Name/Color": "Caprice Khaki",
      Grade: "Basic",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Woven Texture",
      "Color Category": "Browns",
    },
    {
      "Part #": "FAB101278",
      "Fabric Name/Color": "Caprice Midnight",
      Grade: "Basic",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Woven Texture",
      "Color Category": "Blacks & Purples",
    },
    {
      "Part #": "FAB101279",
      "Fabric Name/Color": "Caprice Mink",
      Grade: "Basic",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Woven Texture",
      "Color Category": "Browns",
    },
    {
      "Part #": "FAB201123",
      "Fabric Name/Color": "Casbah Mardi Gras",
      Grade: "Accent/Pillow",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Pattern",
      "Material Type": "Woven Texture",
      "Color Category": "Pink, Red, & Orange",
    },
    {
      "Part #": "FAB201189",
      "Fabric Name/Color": "Catalina Pepper",
      Grade: "Accent/Pillow",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Pattern",
      "Material Type": "Chenille",
      "Color Category": "Blacks & Purples",
    },
    {
      "Part #": "FAB201557",
      "Fabric Name/Color": "Cavandish Tobacco",
      Grade: "Accent/Pillow",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Pattern",
      "Material Type": "Woven Texture",
      "Color Category": "Browns",
    },
    {
      "Part #": "FAB201341",
      "Fabric Name/Color": "Celine Mist",
      Grade: "Basic",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Woven Texture",
      "Color Category": "Blues",
    },
    {
      "Part #": "FAB201340",
      "Fabric Name/Color": "Celine Oatmeal",
      Grade: "Basic",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Woven Texture",
      "Color Category": "Whites & Neutrals",
    },
    {
      "Part #": "FAB201342",
      "Fabric Name/Color": "Celine Pebble",
      Grade: "Basic",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Woven Texture",
      "Color Category": "Greys & Charcoals",
    },
    {
      "Part #": "FAB201473",
      "Fabric Name/Color": "Celine Teal",
      Grade: "Basic",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Woven Texture",
      "Color Category": "Blues",
    },
    {
      "Part #": "FAB101324",
      "Fabric Name/Color": "Chagall Mist",
      Grade: "Accent/Pillow",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Pattern",
      "Material Type": "Jacquard",
      "Color Category": "Greys & Charcoal",
    },
    {
      "Part #": "FAB201856",
      "Fabric Name/Color": "Chandler Cocoa",
      Grade: "Basic",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Chenille",
      "Color Category": "Browns",
    },
    {
      "Part #": "FAB101349",
      "Fabric Name/Color": "Ciao Indigo",
      Grade: "Basic",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Woven Texture",
      "Color Category": "Blues",
    },
    {
      "Part #": "FAB101350",
      "Fabric Name/Color": "Ciao Mercury",
      Grade: "Basic",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Woven Texture",
      "Color Category": "Blacks & Purples",
    },
    {
      "Part #": "FAB101352",
      "Fabric Name/Color": "Cisco Carbon",
      Grade: "Basic",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Velvet",
      "Color Category": "Greys & Charcoal",
    },
    {
      "Part #": "FAB101354",
      "Fabric Name/Color": "Cisco Dove",
      Grade: "Basic",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Velvet",
      "Color Category": "Greys & Charcoal",
    },
    {
      "Part #": "FAB201470",
      "Fabric Name/Color": "Common Thread Eucalyptus",
      Grade: "Basic",
      "JL Upholstery": "JL Design Lab Exclusive",
      "Solid or Pattern": "Solid",
      "Material Type": "Woven Texture",
      "Color Category": "Whites & Neutrals",
    },
    {
      "Part #": "FAB201143",
      "Fabric Name/Color": "Contessa Dove",
      Grade: "Basic",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Velvet",
      "Color Category": "Whites & Neutrals",
    },
    {
      "Part #": "FAB201029",
      "Fabric Name/Color": "Contessa Dusk",
      Grade: "Basic",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Velvet",
      "Color Category": "Blacks & Purples",
    },
    {
      "Part #": "FAB201144",
      "Fabric Name/Color": "Contessa Ivory",
      Grade: "Basic",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Velvet",
      "Color Category": "Whites & Neutrals",
    },
    {
      "Part #": "FAB201002",
      "Fabric Name/Color": "Contessa Paprika",
      Grade: "Basic",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Velvet",
      "Color Category": "Pink, Red, & Orange",
    },
    {
      "Part #": "FAB201003",
      "Fabric Name/Color": "Contessa Shadow",
      Grade: "Basic",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Velvet",
      "Color Category": "Greys & Charcoal",
    },
    {
      "Part #": "FAB200360",
      "Fabric Name/Color": "Continuum Waterfront",
      Grade: "Basic",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Chenille",
      "Color Category": "Blues",
    },
    {
      "Part #": "FAB200432",
      "Fabric Name/Color": "Covenant Indigo",
      Grade: "Accent/Pillow",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Pattern",
      "Material Type": "Woven Texture",
      "Color Category": "Blues",
    },
    {
      "Part #": "FAB200058",
      "Fabric Name/Color": "Creighton Parchment",
      Grade: "Basic",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Woven Texture",
      "Color Category": "Whites & Neutrals",
    },
    {
      "Part #": "FAB200945",
      "Fabric Name/Color": "Cruise White Hot",
      Grade: "Accent/Pillow",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Pattern",
      "Material Type": "Woven Texture",
      "Color Category": "Whites & Neutrals",
    },
    {
      "Part #": "FAB201282",
      "Fabric Name/Color": "Cuba Bark",
      Grade: "Accent/Pillow",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Pattern",
      "Material Type": "Jacquard",
      "Color Category": "Whites & Neutrals",
    },
    {
      "Part #": "FAB200015",
      "Fabric Name/Color": "Curiosity Twilight",
      Grade: "Accent/Pillow",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Pattern",
      "Material Type": "Jacquard",
      "Color Category": "Blues",
    },
    {
      "Part #": "FAB201291",
      "Fabric Name/Color": "Cyrus Clay",
      Grade: "Accent/Pillow",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Pattern",
      "Material Type": "Woven Texture",
      "Color Category": "Whites & Neutrals",
    },
    {
      "Part #": "FAB101401",
      "Fabric Name/Color": "Daddio Kona",
      Grade: "Accent/Pillow",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Pattern",
      "Material Type": "Woven Texture",
      "Color Category": "Greys & Charcoal",
    },
    {
      "Part #": "FAB101403",
      "Fabric Name/Color": "Dante Seaglass",
      Grade: "Accent/Pillow",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Pattern",
      "Material Type": "Jacquard",
      "Color Category": "Greens & Yellows",
    },
    {
      "Part #": "FAB201480",
      "Fabric Name/Color": "Data Sand",
      Grade: "Accent/Pillow",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Pattern",
      "Material Type": "Jacquard",
      "Color Category": "Whites & Neutrals",
    },
    {
      "Part #": "FAB101411",
      "Fabric Name/Color": "Dawson Gunmetal",
      Grade: "Basic",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Woven Texture",
      "Color Category": "Greys & Charcoal",
    },
    {
      "Part #": "FAB101413",
      "Fabric Name/Color": "Dawson Oatmeal",
      Grade: "Basic",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Woven Texture",
      "Color Category": "Whites & Neutrals",
    },
    {
      "Part #": "FAB101416",
      "Fabric Name/Color": "Deauville Dove",
      Grade: "Basic",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Woven Texture",
      "Color Category": "Greys & Charcoal",
    },
    {
      "Part #": "FAB101417",
      "Fabric Name/Color": "Deauville Stone",
      Grade: "Basic",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Woven Texture",
      "Color Category": "Greys & Charcoal",
    },
    {
      "Part #": "FAB201620",
      "Fabric Name/Color": "Degas Dune",
      Grade: "Accent/Pillow",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Pattern",
      "Material Type": "Woven Texture",
      "Color Category": "Whites & Neutrals",
    },
    {
      "Part #": "FAB101442",
      "Fabric Name/Color": "Derby Grey",
      Grade: "Basic",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Chenille",
      "Color Category": "Greys & Charcoal",
    },
    {
      "Part #": "FAB101443",
      "Fabric Name/Color": "Derby Linen",
      Grade: "Basic",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Chenille",
      "Color Category": "Whites & Neutrals",
    },
    {
      "Part #": "FAB101445",
      "Fabric Name/Color": "Derby Taupe",
      Grade: "Basic",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Chenille",
      "Color Category": "Browns",
    },
    {
      "Part #": "FAB101456",
      "Fabric Name/Color": "Devon Pewter",
      Grade: "Basic",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Woven Texture",
      "Color Category": "Greys & Charcoal",
    },
    {
      "Part #": "FAB201307",
      "Fabric Name/Color": "Dominick Driftwood",
      Grade: "Accent/Pillow",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Pattern",
      "Material Type": "Woven Texture",
      "Color Category": "Whites & Neutrals",
    },
    {
      "Part #": "FAB201742",
      "Fabric Name/Color": "Dorsey Aegean",
      Grade: "Accent",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Pattern",
      "Material Type": "Woven Texture",
      "Color Category": "Blues",
    },
    {
      "Part #": "FAB200035",
      "Fabric Name/Color": "Dover Ivory",
      Grade: "Basic",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Woven Texture",
      "Color Category": "Whites & Neutrals",
    },
    {
      "Part #": "FAB101495",
      "Fabric Name/Color": "Dover Natural",
      Grade: "Basic",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Woven Texture",
      "Color Category": "Greys & Charcoal",
    },
    {
      "Part #": "FAB101496",
      "Fabric Name/Color": "Dover Stone",
      Grade: "Basic",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Woven Texture",
      "Color Category": "Whites & Neutrals",
    },
    {
      "Part #": "FAB200738",
      "Fabric Name/Color": "Duomo Beachglass",
      Grade: "Accent/Pillow",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Pattern",
      "Material Type": "Jacquard",
      "Color Category": "Blues",
    },
    {
      "Part #": "LEA100053",
      "Fabric Name/Color": "Echo Granite",
      Grade: "Top Grain Leather",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Leather",
      "Color Category": "Greys & Charcoal",
    },
    {
      "Part #": "LEA100055",
      "Fabric Name/Color": "Echo Lager",
      Grade: "Top Grain Leather",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Leather",
      "Color Category": "Browns",
    },
    {
      "Part #": "LEA100056",
      "Fabric Name/Color": "Echo Limestone",
      Grade: "Top Grain Leather",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Leather",
      "Color Category": "Greys & Charcoal",
    },
    {
      "Part #": "LEA100058",
      "Fabric Name/Color": "Echo Mountain Spring",
      Grade: "Top Grain Leather",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Leather",
      "Color Category": "Blues",
    },
    {
      "Part #": "LEA100059",
      "Fabric Name/Color": "Echo Taupe",
      Grade: "Top Grain Leather",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Leather",
      "Color Category": "Browns",
    },
    {
      "Part #": "LEA100060",
      "Fabric Name/Color": "Echo Umber",
      Grade: "Top Grain Leather",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Leather",
      "Color Category": "Browns",
    },
    {
      "Part #": "FAB200437",
      "Fabric Name/Color": "Edgerly Bluegrass",
      Grade: "Accent/Pillow",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Pattern",
      "Material Type": "Jacquard",
      "Color Category": "Greens & Yellows",
    },
    {
      "Part #": "FAB101538",
      "Fabric Name/Color": "Effloresce Denim",
      Grade: "Accent/Pillow",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Pattern",
      "Material Type": "Jacquard",
      "Color Category": "Blues",
    },
    {
      "Part #": "FAB201331",
      "Fabric Name/Color": "Elaina Aquatint",
      Grade: "Accent/Pillow",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Pattern",
      "Material Type": "Print",
      "Color Category": "Whites & Neutrals",
    },
    {
      "Part #": "FAB201564",
      "Fabric Name/Color": "Elmdorf Bit Of Sugar",
      Grade: "Accent/Pillow",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Pattern",
      "Material Type": "Woven Texture",
      "Color Category": "Whites & Neutrals",
    },
    {
      "Part #": "FAB201838",
      "Fabric Name/Color": "Embark Haystack",
      Grade: "Accent/Pillow",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Pattern",
      "Material Type": "Woven Texture",
      "Color Category": "Browns",
    },
    {
      "Part #": "FAB101564",
      "Fabric Name/Color": "Empire Stone",
      Grade: "Basic",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Velvet",
      "Color Category": "Pink, Red, & Orange",
    },
    {
      "Part #": "FAB201852",
      "Fabric Name/Color": "Enzo Mahogany",
      Grade: "Accent",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Pattern",
      "Material Type": "Print",
      "Color Category": "Browns",
    },
    {
      "Part #": "FAB201728",
      "Fabric Name/Color": "Eriba Twine",
      Grade: "Accent/Pillow",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Pattern",
      "Material Type": "Jaquard",
      "Color Category": "Browns",
    },
    {
      "Part #": "FAB201868",
      "Fabric Name/Color": "Esber Latte",
      Grade: "Basic",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Chenille",
      "Color Category": "Greens & Yellows",
    },
    {
      "Part #": "FAB201867",
      "Fabric Name/Color": "Esber Mushroom",
      Grade: "Basic",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Chenille",
      "Color Category": "Greys & Charcoals",
    },
    {
      "Part #": "FAB201836",
      "Fabric Name/Color": "Esber Pearl",
      Grade: "Basic",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Chenille",
      "Color Category": "Whites & Neutrals",
    },
    {
      "Part #": "FAB201840",
      "Fabric Name/Color": "Esber Rust",
      Grade: "Basic",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Chenille",
      "Color Category": "Blacks & Purples",
    },
    {
      "Part #": "FAB201146",
      "Fabric Name/Color": "Euphoria New Moon",
      Grade: "Basic",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Woven Texture",
      "Color Category": "Whites & Neutrals",
    },
    {
      "Part #": "FAB201148",
      "Fabric Name/Color": "Euphoria White Dove",
      Grade: "Basic",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Woven Texture",
      "Color Category": "Whites & Neutrals",
    },
    {
      "Part #": "FAB201462",
      "Fabric Name/Color": "Farah Bisque",
      Grade: "Accent/Pillow",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Pattern",
      "Material Type": "Jaquard",
      "Color Category": "Whites & Neutrals",
    },
    {
      "Part #": "FAB200997",
      "Fabric Name/Color": "Farina Oatmeal",
      Grade: "Basic",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Chenille",
      "Color Category": "Whites & Neutrals",
    },
    {
      "Part #": "FAB101588",
      "Fabric Name/Color": "Fascinate Versatile",
      Grade: "Accent/Pillow",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Pattern",
      "Material Type": "Jacquard",
      "Color Category": "Greys & Charcoal",
    },
    {
      "Part #": "FAB101589",
      "Fabric Name/Color": "Feivel Tweed",
      Grade: "Accent/Pillow",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Pattern",
      "Material Type": "Jacquard",
      "Color Category": "Browns",
    },
    {
      "Part #": "FAB201777",
      "Fabric Name/Color": "Fez Fur Linen",
      Grade: "Accent",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Pattern",
      "Material Type": "Faux Fur",
      "Color Category": "Whites & Neutrals",
    },
    {
      "Part #": "FAB200133",
      "Fabric Name/Color": "Fine Point Curry",
      Grade: "Accent/Pillow",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Pattern",
      "Material Type": "Canvas/Cotton",
      "Color Category": "Pink, Red, & Orange",
    },
    {
      "Part #": "FAB201202",
      "Fabric Name/Color": "Fino Mineral",
      Grade: "Premium A",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Woven Texture",
      "Color Category": "Whites & Neutrals",
    },
    {
      "Part #": "FAB201204",
      "Fabric Name/Color": "Foundation Smoke",
      Grade: "Accent/Pillow",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Pattern",
      "Material Type": "Jaquard",
      "Color Category": "Blues",
    },
    {
      "Part #": "FAB101639",
      "Fabric Name/Color": "Freckles Silver Fox",
      Grade: "Accent/Pillow",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Pattern",
      "Material Type": "Canvas/Cotton",
      "Color Category": "Blacks & Purples",
    },
    {
      "Part #": "FAB201474",
      "Fabric Name/Color": "Friar Stone",
      Grade: "Basic",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Velvet",
      "Color Category": "Greys & Charcoals",
    },
    {
      "Part #": "FAB201871",
      "Fabric Name/Color": "Frizzle Plum",
      Grade: "Basic",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Chenille",
      "Color Category": "Blacks & Purples",
    },
    {
      "Part #": "FAB101664",
      "Fabric Name/Color": "Furocious Arctic",
      Grade: "Accent/Pillow",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Pattern",
      "Material Type": "Faux Fur",
      "Color Category": "Whites & Neutrals",
    },
    {
      "Part #": "FAB101665",
      "Fabric Name/Color": "Furocious Bear",
      Grade: "Accent/Pillow",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Pattern",
      "Material Type": "Faux Fur",
      "Color Category": "Browns",
    },
    {
      "Part #": "FAB101667",
      "Fabric Name/Color": "Furocious Panther",
      Grade: "Accent/Pillow",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Pattern",
      "Material Type": "Faux Fur",
      "Color Category": "Browns",
    },
    {
      "Part #": "FAB101668",
      "Fabric Name/Color": "Furocious Sable",
      Grade: "Accent/Pillow",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Pattern",
      "Material Type": "Faux Fur",
      "Color Category": "Greys & Charcoal",
    },
    {
      "Part #": "FAB201558",
      "Fabric Name/Color": "Gaga Cuba",
      Grade: "Accent/Pillow",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Pattern",
      "Material Type": "Jaquard",
      "Color Category": "Whites & Neutrals",
    },
    {
      "Part #": "FAB101669",
      "Fabric Name/Color": "Gambella Kona",
      Grade: "Accent/Pillow",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Pattern",
      "Material Type": "Woven Texture",
      "Color Category": "Blacks & Purples",
    },
    {
      "Part #": "FAB201842",
      "Fabric Name/Color": "Gellar Earth",
      Grade: "Basic",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Woven Texture",
      "Color Category": "Browns",
    },
    {
      "Part #": "FAB201789",
      "Fabric Name/Color": "Gellar Linen",
      Grade: "Basic",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Woven Texture",
      "Color Category": "Whites & Neutrals",
    },
    {
      "Part #": "FAB201300",
      "Fabric Name/Color": "Glen Ellen Steel",
      Grade: "Basic",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Linen Look",
      "Color Category": "Blues",
    },
    {
      "Part #": "FAB201128",
      "Fabric Name/Color": "Glen Ellen Stone",
      Grade: "Basic",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Linen Look",
      "Color Category": "Greys & Charcoal",
    },
    {
      "Part #": "FAB201555",
      "Fabric Name/Color": "Goertel Copper",
      Grade: "Accent/Pillow",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Pattern",
      "Material Type": "Jaquard",
      "Color Category": "Pinks, Reds, Oranges",
    },
    {
      "Part #": "FAB201468",
      "Fabric Name/Color": "Goodwin Latte",
      Grade: "Basic",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Woven Texture",
      "Color Category": "Browns",
    },
    {
      "Part #": "FAB201348",
      "Fabric Name/Color": "Goodwin Pebble",
      Grade: "Basic",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Woven Texture",
      "Color Category": "Greys & Charcoal",
    },
    {
      "Part #": "FAB201130",
      "Fabric Name/Color": "Grange Nutmeg",
      Grade: "Accent/Pillow",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Pattern",
      "Material Type": "Jacquard",
      "Color Category": "Browns",
    },
    {
      "Part #": "FAB201296",
      "Fabric Name/Color": "Grogan Denim",
      Grade: "Accent/Pillow",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Pattern",
      "Material Type": "Jacquard",
      "Color Category": "Blues",
    },
    {
      "Part #": "FAB201866",
      "Fabric Name/Color": "Groove Fog",
      Grade: "Basic",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Woven Texture",
      "Color Category": "Greys & Charcoals",
    },
    {
      "Part #": "FAB201752",
      "Fabric Name/Color": "Groove Mahogany",
      Grade: "Basic",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Jaquard",
      "Color Category": "Browns",
    },
    {
      "Part #": "FAB201753",
      "Fabric Name/Color": "Groove Oat",
      Grade: "Basic",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Jaquard",
      "Color Category": "Whites & Neutrals",
    },
    {
      "Part #": "FAB201865",
      "Fabric Name/Color": "Groove Olive",
      Grade: "Basic",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Woven Texture",
      "Color Category": "Greens & Yellows",
    },
    {
      "Part #": "FAB201851",
      "Fabric Name/Color": "Groove Rust",
      Grade: "Basic",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Woven Texture",
      "Color Category": "Pink, Red, & Orange",
    },
    {
      "Part #": "FAB101692",
      "Fabric Name/Color": "Groundwork Indigo",
      Grade: "Accent/Pillow",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Pattern",
      "Material Type": "Jacquard",
      "Color Category": "Blues",
    },
    {
      "Part #": "FAB101695",
      "Fabric Name/Color": "Gypsy Arrow",
      Grade: "Basic",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Chenille",
      "Color Category": "Greens & Yellows",
    },
    {
      "Part #": "FAB101696",
      "Fabric Name/Color": "Gypsy Blue Goblin",
      Grade: "Basic",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Chenille",
      "Color Category": "Blues",
    },
    {
      "Part #": "FAB101697",
      "Fabric Name/Color": "Gypsy Blush",
      Grade: "Basic",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Chenille",
      "Color Category": "Pink, Red, & Orange",
    },
    {
      "Part #": "FAB101699",
      "Fabric Name/Color": "Gypsy Crème",
      Grade: "Basic",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Chenille",
      "Color Category": "Whites & Neutrals",
    },
    {
      "Part #": "FAB101701",
      "Fabric Name/Color": "Gypsy Eggplant",
      Grade: "Basic",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Chenille",
      "Color Category": "Blacks & Purples",
    },
    {
      "Part #": "FAB101705",
      "Fabric Name/Color": "Gypsy Graphite",
      Grade: "Basic",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Chenille",
      "Color Category": "Greys & Charcoal",
    },
    {
      "Part #": "FAB101707",
      "Fabric Name/Color": "Gypsy Navy",
      Grade: "Basic",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Chenille",
      "Color Category": "Blues",
    },
    {
      "Part #": "FAB101708",
      "Fabric Name/Color": "Gypsy Platinum",
      Grade: "Basic",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Chenille",
      "Color Category": "Whites & Neutrals",
    },
    {
      "Part #": "FAB101709",
      "Fabric Name/Color": "Gypsy Quarry",
      Grade: "Basic",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Chenille",
      "Color Category": "Blues",
    },
    {
      "Part #": "FAB101710",
      "Fabric Name/Color": "Gypsy Safari",
      Grade: "Basic",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Chenille",
      "Color Category": "Greens & Yellows",
    },
    {
      "Part #": "FAB101711",
      "Fabric Name/Color": "Gypsy Sage",
      Grade: "Basic",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Chenille",
      "Color Category": "Greens & Yellows",
    },
    {
      "Part #": "FAB101712",
      "Fabric Name/Color": "Gypsy Scarlet",
      Grade: "Basic",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Chenille",
      "Color Category": "Pink, Red, & Orange",
    },
    {
      "Part #": "FAB101714",
      "Fabric Name/Color": "Gypsy Slate",
      Grade: "Basic",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Chenille",
      "Color Category": "Greys & Charcoal",
    },
    {
      "Part #": "FAB101715",
      "Fabric Name/Color": "Gypsy Smoked Pearl",
      Grade: "Basic",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Chenille",
      "Color Category": "Greys & Charcoal",
    },
    {
      "Part #": "FAB101718",
      "Fabric Name/Color": "Gypsy Sunset",
      Grade: "Basic",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Chenille",
      "Color Category": "Pink, Red, & Orange",
    },
    {
      "Part #": "FAB101719",
      "Fabric Name/Color": "Gypsy Taupe",
      Grade: "Basic",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Chenille",
      "Color Category": "Browns",
    },
    {
      "Part #": "FAB101720",
      "Fabric Name/Color": "Gypsy Teal",
      Grade: "Basic",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Chenille",
      "Color Category": "Greens & Yellows",
    },
    {
      "Part #": "FAB101721",
      "Fabric Name/Color": "Gypsy Truffle",
      Grade: "Basic",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Chenille",
      "Color Category": "Browns",
    },
    {
      "Part #": "FAB101722",
      "Fabric Name/Color": "Gypsy Vapor",
      Grade: "Basic",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Chenille",
      "Color Category": "Whites & Neutrals",
    },
    {
      "Part #": "FAB101723",
      "Fabric Name/Color": "Gypsy Vintage",
      Grade: "Basic",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Chenille",
      "Color Category": "Browns",
    },
    {
      "Part #": "FAB201308",
      "Fabric Name/Color": "Hakimi Ivory",
      Grade: "Accent/Pillow",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Pattern",
      "Material Type": "Jaquard",
      "Color Category": "Whites & Neutrals",
    },
    {
      "Part #": "LEA100080",
      "Fabric Name/Color": "Harness Charcoal",
      Grade: "Top Grain Leather",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Leather",
      "Color Category": "Greys & Charcoal",
    },
    {
      "Part #": "FAB101732",
      "Fabric Name/Color": "Heavenly Apple",
      Grade: "Basic",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Woven Texture",
      "Color Category": "Greens & Yellows",
    },
    {
      "Part #": "FAB101733",
      "Fabric Name/Color": "Heavenly Café",
      Grade: "Basic",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Woven Texture",
      "Color Category": "Browns",
    },
    {
      "Part #": "FAB101734",
      "Fabric Name/Color": "Heavenly Caramel",
      Grade: "Basic",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Woven Texture",
      "Color Category": "Whites & Neutrals",
    },
    {
      "Part #": "FAB101735",
      "Fabric Name/Color": "Heavenly Chrome",
      Grade: "Basic",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Woven Texture",
      "Color Category": "Greys & Charcoal",
    },
    {
      "Part #": "FAB101736",
      "Fabric Name/Color": "Heavenly Cinder",
      Grade: "Basic",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Woven Texture",
      "Color Category": "Greys & Charcoal",
    },
    {
      "Part #": "FAB101737",
      "Fabric Name/Color": "Heavenly Java",
      Grade: "Basic",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Woven Texture",
      "Color Category": "Browns",
    },
    {
      "Part #": "FAB101739",
      "Fabric Name/Color": "Heavenly Mocha",
      Grade: "Basic",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Woven Texture",
      "Color Category": "Browns",
    },
    {
      "Part #": "FAB101740",
      "Fabric Name/Color": "Heavenly Mulberry",
      Grade: "Basic",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Woven Texture",
      "Color Category": "Pink, Red, & Orange",
    },
    {
      "Part #": "FAB101741",
      "Fabric Name/Color": "Heavenly Naval",
      Grade: "Basic",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Woven Texture",
      "Color Category": "Blues",
    },
    {
      "Part #": "FAB101742",
      "Fabric Name/Color": "Heavenly Olive",
      Grade: "Basic",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Woven Texture",
      "Color Category": "Greens & Yellows",
    },
    {
      "Part #": "FAB101743",
      "Fabric Name/Color": "Heavenly Oyster",
      Grade: "Basic",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Woven Texture",
      "Color Category": "Whites & Neutrals",
    },
    {
      "Part #": "FAB101744",
      "Fabric Name/Color": "Heavenly Robins Egg",
      Grade: "Basic",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Woven Texture",
      "Color Category": "Blues",
    },
    {
      "Part #": "FAB101745",
      "Fabric Name/Color": "Heavenly Sapphire",
      Grade: "Basic",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Woven Texture",
      "Color Category": "Blues",
    },
    {
      "Part #": "FAB201125",
      "Fabric Name/Color": "Heflin Parchment",
      Grade: "Accent/Pillow",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Pattern",
      "Material Type": "Jacquard",
      "Color Category": "Whites & Neutrals",
    },
    {
      "Part #": "FAB201618",
      "Fabric Name/Color": "Hendifar Driftwood",
      Grade: "Accent/Pillow",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Pattern",
      "Material Type": "Jaquard",
      "Color Category": "Greys & Charcoals",
    },
    {
      "Part #": "FAB201726",
      "Fabric Name/Color": "Henequen Ivory",
      Grade: "Basic",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Chenille",
      "Color Category": "Whites & Neutrals",
    },
    {
      "Part #": "FAB201551",
      "Fabric Name/Color": "Henequen Oatmeal",
      Grade: "Basic",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Chenille",
      "Color Category": "Whites & Neutrals",
    },
    {
      "Part #": "FAB201617",
      "Fabric Name/Color": "Henequen Pearl",
      Grade: "Basic",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Chenille",
      "Color Category": "Whites & Neutrals",
    },
    {
      "Part #": "FAB201616",
      "Fabric Name/Color": "Henequen Slate",
      Grade: "Basic",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Chenille",
      "Color Category": "Blues",
    },
    {
      "Part #": "FAB201288",
      "Fabric Name/Color": "Henson Birch",
      Grade: "Accent/Pillow",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Pattern",
      "Material Type": "Woven Texture",
      "Color Category": "Browns",
    },
    {
      "Part #": "FAB101758",
      "Fabric Name/Color": "Heveron Onyx",
      Grade: "Accent/Pillow",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Pattern",
      "Material Type": "Chenille",
      "Color Category": "Whites & Neutrals",
    },
    {
      "Part #": "FAB201782",
      "Fabric Name/Color": "Highland Ecru",
      Grade: "Basic",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Jaquard",
      "Color Category": "Whites & Neutrals",
    },
    {
      "Part #": "FAB101759",
      "Fabric Name/Color": "Hipster Silver",
      Grade: "Accent/Pillow",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Pattern",
      "Material Type": "Velvet",
      "Color Category": "Greys & Charcoal",
    },
    {
      "Part #": "LEA100062",
      "Fabric Name/Color": "Holland Pearl",
      Grade: "Top Grain Leather",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Leather",
      "Color Category": "Whites & Neutrals",
    },
    {
      "Part #": "LEA100063",
      "Fabric Name/Color": "Holland Sky",
      Grade: "Top Grain Leather",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Leather",
      "Color Category": "Blues",
    },
    {
      "Part #": "FAB200199",
      "Fabric Name/Color": "Hybrid Adobe",
      Grade: "Accent/Pillow",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Pattern",
      "Material Type": "Woven Texture",
      "Color Category": "Browns",
    },
    {
      "Part #": "FAB201750",
      "Fabric Name/Color": "Ihara Coral Blue",
      Grade: "Accent",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Pattern",
      "Material Type": "Woven Texture",
      "Color Category": "Pink, Red, & Orange",
    },
    {
      "Part #": "FAB200923",
      "Fabric Name/Color": "Isla Sunset",
      Grade: "Accent/Pillow",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Pattern",
      "Material Type": "Jacquard",
      "Color Category": "Pink, Red, & Orange",
    },
    {
      "Part #": "FAB200926",
      "Fabric Name/Color": "Jamboree Oasis",
      Grade: "Accent/Pillow",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Pattern",
      "Material Type": "Jacquard",
      "Color Category": "Blues",
    },
    {
      "Part #": "FAB201853",
      "Fabric Name/Color": "Jango Sage",
      Grade: "Accent",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Pattern",
      "Material Type": "Jacquard",
      "Color Category": "Whites & Neutrals",
    },
    {
      "Part #": "FAB201245",
      "Fabric Name/Color": "Jaspar Desert",
      Grade: "Accent/Pillow",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Pattern",
      "Material Type": "Jacquard",
      "Color Category": "Browns",
    },
    {
      "Part #": "FAB101791",
      "Fabric Name/Color": "Jigsaw Goldstone",
      Grade: "Accent/Pillow",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Pattern",
      "Material Type": "Jacquard",
      "Color Category": "Greys & Charcoal",
    },
    {
      "Part #": "FAB201066",
      "Fabric Name/Color": "Jobrani Dune",
      Grade: "Accent/Pillow",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Pattern",
      "Material Type": "Jacquard",
      "Color Category": "Whites & Neutrals",
    },
    {
      "Part #": "FAB201475",
      "Fabric Name/Color": "Joker Moonstone",
      Grade: "Accent/Pillow",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Pattern",
      "Material Type": "Jacquard",
      "Color Category": "Blues",
    },
    {
      "Part #": "FAB201732",
      "Fabric Name/Color": "Joplin Burlap",
      Grade: "Accent/Pillow",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Pattern",
      "Material Type": "Jaquard",
      "Color Category": "Browns",
    },
    {
      "Part #": "FAB200072",
      "Fabric Name/Color": "Jubilee Mint",
      Grade: "Premium A",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Woven Texture",
      "Color Category": "Blues",
    },
    {
      "Part #": "FAB200019",
      "Fabric Name/Color": "Jubilee Pearl",
      Grade: "Premium A",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Woven Texture",
      "Color Category": "Whites & Neutrals",
    },
    {
      "Part #": "FAB200441",
      "Fabric Name/Color": "Julana Kuba",
      Grade: "Accent/Pillow",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Pattern",
      "Material Type": "Jacquard",
      "Color Category": "Browns",
    },
    {
      "Part #": "FAB201630",
      "Fabric Name/Color": "Kali Porcelain",
      Grade: "Accent/Pillow",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Pattern",
      "Material Type": "Jaquard",
      "Color Category": "Whites & Neutrals",
    },
    {
      "Part #": "FAB201378",
      "Fabric Name/Color": "Kanjari Cashew",
      Grade: "Accent/Pillow",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Pattern",
      "Material Type": "Jacquard",
      "Color Category": "Browns",
    },
    {
      "Part #": "FAB201854",
      "Fabric Name/Color": "Karma Dove",
      Grade: "Basic",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Chenille",
      "Color Category": "Greys & Charcoal",
    },
    {
      "Part #": "FAB201855",
      "Fabric Name/Color": "Karma Pebble",
      Grade: "Basic",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Chenille",
      "Color Category": "Whites & Neutrals",
    },
    {
      "Part #": "FAB200132",
      "Fabric Name/Color": "Katalina Shell",
      Grade: "Accent/Pillow",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Pattern",
      "Material Type": "Velvet",
      "Color Category": "Blues",
    },
    {
      "Part #": "FAB200332",
      "Fabric Name/Color": "Keebler Tuxedo",
      Grade: "Accent/Pillow",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Pattern",
      "Material Type": "Jacquard",
      "Color Category": "Blacks & Purples",
    },
    {
      "Part #": "FAB201478",
      "Fabric Name/Color": "Kelly Ivory",
      Grade: "Accent/Pillow",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Pattern",
      "Material Type": "Jacquard",
      "Color Category": "Whites & Neutrals",
    },
    {
      "Part #": "fab200013",
      "Fabric Name/Color": "Kerryn Raspberry",
      Grade: "Accent/Pillow",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Pattern",
      "Material Type": "Jacquard",
      "Color Category": "Pink, Red, & Orange",
    },
    {
      "Part #": "FAB201556",
      "Fabric Name/Color": "Kikkan Fresco",
      Grade: "Accent/Pillow",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Pattern",
      "Material Type": "Jaquard",
      "Color Category": "Pinks, Reds, Oranges",
    },
    {
      "Part #": "FAB201290",
      "Fabric Name/Color": "Kikkan Mineral",
      Grade: "Accent/Pillow",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Pattern",
      "Material Type": "Woven Texture",
      "Color Category": "Blues",
    },
    {
      "Part #": "LEA100068",
      "Fabric Name/Color": "Kipling Metallic Onyx",
      Grade: "Top Grain Leather",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Leather",
      "Color Category": "Greys & Charcoal",
    },
    {
      "Part #": "FAB201546",
      "Fabric Name/Color": "Klonicki Tranquil",
      Grade: "Accent/Pillow",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Pattern",
      "Material Type": "Jaquard",
      "Color Category": "Blues",
    },
    {
      "Part #": "FAB201626",
      "Fabric Name/Color": "Krasna Tortoise",
      Grade: "Accent/Pillow",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Pattern",
      "Material Type": "Jaquard",
      "Color Category": "Browns",
    },
    {
      "Part #": "FAB201482",
      "Fabric Name/Color": "Lafayette Mica",
      Grade: "Accent/Pillow",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Pattern",
      "Material Type": "Print",
      "Color Category": "Whites & Neutrals",
    },
    {
      "Part #": "FAB201120",
      "Fabric Name/Color": "Lakelawn Natural",
      Grade: "Basic",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Chenille",
      "Color Category": "Whites & Neutrals",
    },
    {
      "Part #": "FAB201839",
      "Fabric Name/Color": "Larocca Burlap",
      Grade: "Accent/Pillow",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Faux Fur",
      "Color Category": "Whites & Neutrals",
    },
    {
      "Part #": "LEA100092",
      "Fabric Name/Color": "Larsen Sandcastle",
      Grade: "Top Grain Leather",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Leather",
      "Color Category": "Browns",
    },
    {
      "Part #": "FAB201286",
      "Fabric Name/Color": "Letterman Copper",
      Grade: "Accent/Pillow",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Pattern",
      "Material Type": "Woven Texture",
      "Color Category": "Pink, Red, & Orange",
    },
    {
      "Part #": "FAB101844",
      "Fabric Name/Color": "Linus Platinum",
      Grade: "Basic",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Woven Texture",
      "Color Category": "Whites & Neutrals",
    },
    {
      "Part #": "FAB101845",
      "Fabric Name/Color": "Linus Sterling",
      Grade: "Basic",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Woven Texture",
      "Color Category": "Browns",
    },
    {
      "Part #": "FAB101849",
      "Fabric Name/Color": "Llama Fur Charcoal",
      Grade: "Accent/Pillow",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Pattern",
      "Material Type": "Faux Fur",
      "Color Category": "Greys & Charcoal",
    },
    {
      "Part #": "FAB101850",
      "Fabric Name/Color": "Llama Fur Sand",
      Grade: "Accent/Pillow",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Pattern",
      "Material Type": "Faux Fur",
      "Color Category": "Whites & Neutrals",
    },
    {
      "Part #": "FAB101851",
      "Fabric Name/Color": "Llama Fur Silver",
      Grade: "Accent/Pillow",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Pattern",
      "Material Type": "Faux Fur",
      "Color Category": "Greys & Charcoal",
    },
    {
      "Part #": "FAB101852",
      "Fabric Name/Color": "Llama Fur Snow White",
      Grade: "Accent/Pillow",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Pattern",
      "Material Type": "Faux Fur",
      "Color Category": "Whites & Neutrals",
    },
    {
      "Part #": "FAB201356",
      "Fabric Name/Color": "Lovely Dove",
      Grade: "Basic",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Chenille",
      "Color Category": "Whites & Neutrals",
    },
    {
      "Part #": "FAB201354",
      "Fabric Name/Color": "Lovely French Blue",
      Grade: "Basic",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Chenille",
      "Color Category": "Blues",
    },
    {
      "Part #": "FAB201355",
      "Fabric Name/Color": "Lovely Russet",
      Grade: "Basic",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Chenille",
      "Color Category": "Pinks, Reds, Oranges",
    },
    {
      "Part #": "FAB201627",
      "Fabric Name/Color": "Lucienne Folklore",
      Grade: "Accent/Pillow",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Pattern",
      "Material Type": "Print",
      "Color Category": "Whites & Neutrals",
    },
    {
      "Part #": "FAB201472",
      "Fabric Name/Color": "Luna Fog",
      Grade: "Accent/Pillow",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Pattern",
      "Material Type": "Jaquard",
      "Color Category": "Whites & Neutrals",
    },
    {
      "Part #": "FAB201368",
      "Fabric Name/Color": "Lyman Cornsilk",
      Grade: "Accent/Pillow",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Pattern",
      "Material Type": "Print",
      "Color Category": "Greens & Yellows",
    },
    {
      "Part #": "FAB201559",
      "Fabric Name/Color": "Mahler Grove",
      Grade: "Accent/Pillow",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Pattern",
      "Material Type": "Jaquard",
      "Color Category": "Greens & Yellows",
    },
    {
      "Part #": "FAB201289",
      "Fabric Name/Color": "Maldon Copper",
      Grade: "Accent/Pillow",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Pattern",
      "Material Type": "Woven Texture",
      "Color Category": "Pinks, Reds, Oranges",
    },
    {
      "Part #": "FAB101878",
      "Fabric Name/Color": "Malibu Dove",
      Grade: "Basic",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Linen Look",
      "Color Category": "Greys & Charcoal",
    },
    {
      "Part #": "FAB101880",
      "Fabric Name/Color": "Malibu Linen",
      Grade: "Basic",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Linen Look",
      "Color Category": "Whites & Neutrals",
    },
    {
      "Part #": "FAB101881",
      "Fabric Name/Color": "Malibu Sand",
      Grade: "Basic",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Linen Look",
      "Color Category": "Whites & Neutrals",
    },
    {
      "Part #": "FAB201465",
      "Fabric Name/Color": "Marbella Tannery",
      Grade: "Accent/Pillow",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Pattern",
      "Material Type": "Print",
      "Color Category": "Browns",
    },
    {
      "Part #": "FAB200928",
      "Fabric Name/Color": "Marin Breeze",
      Grade: "Basic",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Chenille",
      "Color Category": "Blues",
    },
    {
      "Part #": "FAB200950",
      "Fabric Name/Color": "Marin Sunflower",
      Grade: "Basic",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Chenille",
      "Color Category": "Greens & Yellows",
    },
    {
      "Part #": "FAB200727",
      "Fabric Name/Color": "Marley Navy",
      Grade: "Basic",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Woven Texture",
      "Color Category": "Blues",
    },
    {
      "Part #": "FAB200726",
      "Fabric Name/Color": "Marley Olive",
      Grade: "Basic",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Woven Texture",
      "Color Category": "Greens & Yellows",
    },
    {
      "Part #": "FAB200725",
      "Fabric Name/Color": "Marley Sand",
      Grade: "Basic",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Woven Texture",
      "Color Category": "Whites & Neutrals",
    },
    {
      "Part #": "FAB101888",
      "Fabric Name/Color": "Marmont White",
      Grade: "Accent/Pillow",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Pattern",
      "Material Type": "Chenille",
      "Color Category": "Whites & Neutrals",
    },
    {
      "Part #": "FAB201548",
      "Fabric Name/Color": "Marquis Surf",
      Grade: "Basic",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Velvet",
      "Color Category": "Blues",
    },
    {
      "Part #": "FAB201292",
      "Fabric Name/Color": "Marrazos Seaglass",
      Grade: "Accent/Pillow",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Pattern",
      "Material Type": "Jaquard",
      "Color Category": "Blues",
    },
    {
      "Part #": "FAB200139",
      "Fabric Name/Color": "Masterpiece Turmeric",
      Grade: "Accent/Pillow",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Pattern",
      "Material Type": "Woven Texture",
      "Color Category": "Pink, Red, & Orange",
    },
    {
      "Part #": "FAB201344",
      "Fabric Name/Color": "Matisse Camel",
      Grade: "Basic",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Chenille",
      "Color Category": "Browns",
    },
    {
      "Part #": "FAB201343",
      "Fabric Name/Color": "Matisse Jade",
      Grade: "Basic",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Chenille",
      "Color Category": "Greens & Yellows",
    },
    {
      "Part #": "FAB201345",
      "Fabric Name/Color": "Matisse Oyster",
      Grade: "Basic",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Chenille",
      "Color Category": "Whites & Neutrals",
    },
    {
      "Part #": "FAB201050",
      "Fabric Name/Color": "Matoya Pekoe",
      Grade: "Accent/Pillow",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Pattern",
      "Material Type": "Jacquard",
      "Color Category": "Pink, Red, & Orange",
    },
    {
      "Part #": "FAB201715",
      "Fabric Name/Color": "Maven Carbon",
      Grade: "Basic",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Chenille",
      "Color Category": "Greys & Charcoals",
    },
    {
      "Part #": "FAB201631",
      "Fabric Name/Color": "Maven Forest",
      Grade: "Basic",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Chenille",
      "Color Category": "Greens & Yellows",
    },
    {
      "Part #": "FAB201771",
      "Fabric Name/Color": "Maven Ginger",
      Grade: "Basic",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Chenille",
      "Color Category": "Pinks, Reds, Oranges",
    },
    {
      "Part #": "FAB201632",
      "Fabric Name/Color": "Maven Rust",
      Grade: "Basic",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Chenille",
      "Color Category": "Pinks, Reds, Oranges",
    },
    {
      "Part #": "FAB200524",
      "Fabric Name/Color": "Maya Caramel",
      Grade: "Accent/Pillow",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Pattern",
      "Material Type": "Velvet",
      "Color Category": "Pink, Red, & Orange",
    },
    {
      "Part #": "FAB101904",
      "Fabric Name/Color": "Meatball Ivory",
      Grade: "Accent/Pillow",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Pattern",
      "Material Type": "Chenille",
      "Color Category": "Whites & Neutrals",
    },
    {
      "Part #": "FAB200160",
      "Fabric Name/Color": "Media Granite",
      Grade: "Accent/Pillow",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Pattern",
      "Material Type": "Jacquard",
      "Color Category": "Greys & Charcoal",
    },
    {
      "Part #": "FAB201461",
      "Fabric Name/Color": "Melba Moon",
      Grade: "Accent/Pillow",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Pattern",
      "Material Type": "Jaquard",
      "Color Category": "Greys & Charcoals",
    },
    {
      "Part #": "FAB201238",
      "Fabric Name/Color": "Menounos Twine",
      Grade: "Accent/Pillow",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Pattern",
      "Material Type": "Jacquard",
      "Color Category": "Whites & Neutrals",
    },
    {
      "Part #": "FAB101927",
      "Fabric Name/Color": "Merit Charcoal",
      Grade: "Basic",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Woven Texture",
      "Color Category": "Greys & Charcoal",
    },
    {
      "Part #": "FAB101928",
      "Fabric Name/Color": "Merit Dove",
      Grade: "Basic",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Woven Texture",
      "Color Category": "Whites & Neutrals",
    },
    {
      "Part #": "FAB101929",
      "Fabric Name/Color": "Merit Greystone",
      Grade: "Basic",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Woven Texture",
      "Color Category": "Whites & Neutrals",
    },
    {
      "Part #": "FAB201265",
      "Fabric Name/Color": "Merit Mist",
      Grade: "Basic",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Woven Texture",
      "Color Category": "Blues",
    },
    {
      "Part #": "FAB101930",
      "Fabric Name/Color": "Merit Peacock",
      Grade: "Basic",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Woven Texture",
      "Color Category": "Greens & Yellows",
    },
    {
      "Part #": "FAB101931",
      "Fabric Name/Color": "Merit Pearl",
      Grade: "Basic",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Woven Texture",
      "Color Category": "Whites & Neutrals",
    },
    {
      "Part #": "FAB200135",
      "Fabric Name/Color": "Merit Snow",
      Grade: "Basic",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Woven Texture",
      "Color Category": "Whites & Neutrals",
    },
    {
      "Part #": "FAB201862",
      "Fabric Name/Color": "Mesa Bronze",
      Grade: "Basic",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Woven Texture",
      "Color Category": "Browns",
    },
    {
      "Part #": "FAB201832",
      "Fabric Name/Color": "Mesa Milkglass",
      Grade: "Basic",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Chenille",
      "Color Category": "Blues",
    },
    {
      "Part #": "FAB201860",
      "Fabric Name/Color": "Mesa Snow",
      Grade: "Basic",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Woven Texture",
      "Color Category": "Whites & Neutrals",
    },
    {
      "Part #": "FAB201621",
      "Fabric Name/Color": "Mesero Fog",
      Grade: "Basic",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Chenille",
      "Color Category": "Greys & Charcoals",
    },
    {
      "Part #": "FAB201622",
      "Fabric Name/Color": "Mesero Latte",
      Grade: "Basic",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Chenille",
      "Color Category": "Greens & Yellows",
    },
    {
      "Part #": "FAB201751",
      "Fabric Name/Color": "Mesero Mocha",
      Grade: "Basic",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Jaquard",
      "Color Category": "",
    },
    {
      "Part #": "FAB201731",
      "Fabric Name/Color": "Mesero Oat",
      Grade: "Basic",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Chenille",
      "Color Category": "Whites & Neutrals",
    },
    {
      "Part #": "FAB201717",
      "Fabric Name/Color": "Mesero Spice",
      Grade: "Basic",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Chenille",
      "Color Category": "Pinks, Reds, Oranges",
    },
    {
      "Part #": "FAB201733",
      "Fabric Name/Color": "Mesero Surf",
      Grade: "Basic",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Chenille",
      "Color Category": "Blues",
    },
    {
      "Part #": "FAB201190",
      "Fabric Name/Color": "Metaphor Jetset",
      Grade: "Basic",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Woven Texture",
      "Color Category": "Blacks & Purples",
    },
    {
      "Part #": "FAB201191",
      "Fabric Name/Color": "Metaphor Winter",
      Grade: "Basic",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Woven Texture",
      "Color Category": "Whites & Neutrals",
    },
    {
      "Part #": "FAB201059",
      "Fabric Name/Color": "Milliken Natural",
      Grade: "Accent/Pillow",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Pattern",
      "Material Type": "Woven Texture",
      "Color Category": "Whites & Neutrals",
    },
    {
      "Part #": "FAB201749",
      "Fabric Name/Color": "Mimi Topaz",
      Grade: "Accent",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Pattern",
      "Material Type": "Woven Texture",
      "Color Category": "Whites & Neutrals",
    },
    {
      "Part #": "FAB200980",
      "Fabric Name/Color": "Mineya Meadow",
      Grade: "Accent/Pillow",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Pattern",
      "Material Type": "Jacquard",
      "Color Category": "Blues",
    },
    {
      "Part #": "FAB101940",
      "Fabric Name/Color": "Mitos Heather",
      Grade: "Accent/Pillow",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Pattern",
      "Material Type": "Jacquard",
      "Color Category": "Blues",
    },
    {
      "Part #": "FAB101943",
      "Fabric Name/Color": "Mitos Taupe",
      Grade: "Accent/Pillow",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Pattern",
      "Material Type": "Jacquard",
      "Color Category": "Greys & Charcoal",
    },
    {
      "Part #": "FAB101956",
      "Fabric Name/Color": "Monaco Avocado",
      Grade: "Premium B",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Velvet",
      "Color Category": "Greens & Yellows",
    },
    {
      "Part #": "FAB101958",
      "Fabric Name/Color": "Monaco Coal",
      Grade: "Premium B",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Velvet",
      "Color Category": "Blacks & Purples",
    },
    {
      "Part #": "FAB101959",
      "Fabric Name/Color": "Monaco Coffee",
      Grade: "Premium B",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Velvet",
      "Color Category": "Browns",
    },
    {
      "Part #": "FAB101961",
      "Fabric Name/Color": "Monaco Emerald",
      Grade: "Premium B",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Velvet",
      "Color Category": "Greens & Yellows",
    },
    {
      "Part #": "FAB101962",
      "Fabric Name/Color": "Monaco Ink",
      Grade: "Premium B",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Velvet",
      "Color Category": "Blues",
    },
    {
      "Part #": "FAB101963",
      "Fabric Name/Color": "Monaco Mondo",
      Grade: "Premium B",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Velvet",
      "Color Category": "Whites & Neutrals",
    },
    {
      "Part #": "FAB101965",
      "Fabric Name/Color": "Monaco Rust",
      Grade: "Premium B",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Velvet",
      "Color Category": "Pink, Red, & Orange",
    },
    {
      "Part #": "FAB101966",
      "Fabric Name/Color": "Monaco Spa",
      Grade: "Premium B",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Velvet",
      "Color Category": "Blues",
    },
    {
      "Part #": "LEA100070",
      "Fabric Name/Color": "Mont Blanc Anthracite",
      Grade: "Top Grain Leather",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Leather",
      "Color Category": "Browns",
    },
    {
      "Part #": "LEA100071",
      "Fabric Name/Color": "Mont Blanc Chianti",
      Grade: "Top Grain Leather",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Leather",
      "Color Category": "Browns",
    },
    {
      "Part #": "FAB201964",
      "Fabric Name/Color": "Royce Antique",
      Grade: "Accent & Pillow",
      "JL Upholstery": "JL Catalog",
      "Solid or Pattern": "Pattern",
      "Material Type": "Woven Texture",
      "Color Category": "Whites & Neutrals",
    },
    {
      "Part #": "LEA100083",
      "Fabric Name/Color": "Mont Blanc Iron",
      Grade: "Top Grain Leather",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Leather",
      "Color Category": "Greys & Charcoal",
    },
    {
      "Part #": "LEA100073",
      "Fabric Name/Color": "Mont Blanc Ivory",
      Grade: "Top Grain Leather",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Leather",
      "Color Category": "Whites & Neutrals",
    },
    {
      "Part #": "LEA100081",
      "Fabric Name/Color": "Mont Blanc Mauve",
      Grade: "Top Grain Leather",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Leather",
      "Color Category": "Pink, Red, & Orange",
    },
    {
      "Part #": "LEA100075",
      "Fabric Name/Color": "Mont Blanc Tangerine",
      Grade: "Top Grain Leather",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Leather",
      "Color Category": "Pink, Red, & Orange",
    },
    {
      "Part #": "FAB201861",
      "Fabric Name/Color": "Montage Birch",
      Grade: "Premium",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Chenille",
      "Color Category": "Whites & Neutrals",
    },
    {
      "Part #": "FAB101970",
      "Fabric Name/Color": "Montera Whitesand",
      Grade: "Basic",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Chenille",
      "Color Category": "Whites & Neutrals",
    },
    {
      "Part #": "FAB101971",
      "Fabric Name/Color": "Monterrey Pebble",
      Grade: "Premium A",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Woven Texture",
      "Color Category": "Whites & Neutrals",
    },
    {
      "Part #": "FAB201131",
      "Fabric Name/Color": "Moonwalk Nutmeg",
      Grade: "Accent/Pillow",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Pattern",
      "Material Type": "Jacquard",
      "Color Category": "Browns",
    },
    {
      "Part #": "FAB101975",
      "Fabric Name/Color": "Mr. Cheetah Flannel",
      Grade: "Accent/Pillow",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Pattern",
      "Material Type": "Jacquard",
      "Color Category": "Browns",
    },
    {
      "Part #": "FAB200120",
      "Fabric Name/Color": "Munich Metal",
      Grade: "Accent/Pillow",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Pattern",
      "Material Type": "Chenille",
      "Color Category": "Blacks & Purples",
    },
    {
      "Part #": "FAB201149",
      "Fabric Name/Color": "Muse Stone",
      Grade: "Basic",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Woven Texture",
      "Color Category": "Greys & Charcoal",
    },
    {
      "Part #": "FAB200348",
      "Fabric Name/Color": "Napa Brown",
      Grade: "Basic",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Chenille",
      "Color Category": "Browns",
    },
    {
      "Part #": "FAB200346",
      "Fabric Name/Color": "Napa Navy",
      Grade: "Basic",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Chenille",
      "Color Category": "Blues",
    },
    {
      "Part #": "FAB200344",
      "Fabric Name/Color": "Napa Steel",
      Grade: "Basic",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Chenille",
      "Color Category": "Greys & Charcoal",
    },
    {
      "Part #": "FAB200349",
      "Fabric Name/Color": "Napa Storm",
      Grade: "Basic",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Chenille",
      "Color Category": "Greys & Charcoal",
    },
    {
      "Part #": "FAB200347",
      "Fabric Name/Color": "Napa Taupe",
      Grade: "Basic",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Chenille",
      "Color Category": "Whites & Neutrals",
    },
    {
      "Part #": "FAB200345",
      "Fabric Name/Color": "Napa Teal",
      Grade: "Basic",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Chenille",
      "Color Category": "Blues",
    },
    {
      "Part #": "FAB200343",
      "Fabric Name/Color": "Napa Vintage",
      Grade: "Basic",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Chenille",
      "Color Category": "Greys & Charcoal",
    },
    {
      "Part #": "FAB201068",
      "Fabric Name/Color": "Naples Sterling",
      Grade: "Accent/Pillow",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Pattern",
      "Material Type": "Print",
      "Color Category": "Blues",
    },
    {
      "Part #": "FAB101986",
      "Fabric Name/Color": "Natori Blaze",
      Grade: "Accent/Pillow",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Pattern",
      "Material Type": "Chenille",
      "Color Category": "Pink, Red, & Orange",
    },
    {
      "Part #": "FAB200514",
      "Fabric Name/Color": "Nepal Clay",
      Grade: "Premium A",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Chenille",
      "Color Category": "Pink, Red, & Orange",
    },
    {
      "Part #": "FAB200513",
      "Fabric Name/Color": "Nepal French Blue",
      Grade: "Premium A",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Chenille",
      "Color Category": "Blues",
    },
    {
      "Part #": "FAB201011",
      "Fabric Name/Color": "Noloni Porcelain",
      Grade: "Accent/Pillow",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Pattern",
      "Material Type": "Jacquard",
      "Color Category": "Whites & Neutrals",
    },
    {
      "Part #": "FAB201302",
      "Fabric Name/Color": "Nottingham Slate",
      Grade: "Basic",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Woven Texture",
      "Color Category": "Blues",
    },
    {
      "Part #": "FAB201301",
      "Fabric Name/Color": "Nottingham Tuxedo",
      Grade: "Basic",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Woven Texture",
      "Color Category": "Blacks & Purples",
    },
    {
      "Part #": "FAB102006",
      "Fabric Name/Color": "Ocampo Dusk",
      Grade: "Accent/Pillow",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Pattern",
      "Material Type": "Jacquard",
      "Color Category": "Blues",
    },
    {
      "Part #": "FAB201018",
      "Fabric Name/Color": "Odin Mineral",
      Grade: "Accent/Pillow",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Pattern",
      "Material Type": "Jacquard",
      "Color Category": "Blues",
    },
    {
      "Part #": "FAB201007",
      "Fabric Name/Color": "Oh Brother Ocean",
      Grade: "Accent/Pillow",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Pattern",
      "Material Type": "Woven Texture",
      "Color Category": "Blues",
    },
    {
      "Part #": "FAB201193",
      "Fabric Name/Color": "Ollieroo Pewter",
      Grade: "Accent/Pillow",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Pattern",
      "Material Type": "Jacquard",
      "Color Category": "Blacks & Purples",
    },
    {
      "Part #": "FAB201246",
      "Fabric Name/Color": "Ollieroo Sisal",
      Grade: "Accent/Pillow",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Pattern",
      "Material Type": "Jacquard",
      "Color Category": "Whites & Neutrals",
    },
    {
      "Part #": "FAB201778",
      "Fabric Name/Color": "Ophelia Dove",
      Grade: "Basic",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Jaquard",
      "Color Category": "Whites & Neutrals",
    },
    {
      "Part #": "FAB102013",
      "Fabric Name/Color": "Opulent Margarita",
      Grade: "Premium A",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Velvet",
      "Color Category": "Greens & Yellows",
    },
    {
      "Part #": "FAB102014",
      "Fabric Name/Color": "Opulent Polar",
      Grade: "Premium A",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Velvet",
      "Color Category": "Whites & Neutrals",
    },
    {
      "Part #": "FAB102015",
      "Fabric Name/Color": "Opulent Seal",
      Grade: "Premium A",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Velvet",
      "Color Category": "Greys & Charcoal",
    },
    {
      "Part #": "FAB102016",
      "Fabric Name/Color": "Opulent Snow",
      Grade: "Premium A",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Velvet",
      "Color Category": "Whites & Neutrals",
    },
    {
      "Part #": "FAB201769",
      "Fabric Name/Color": "Oxford Platinum",
      Grade: "Basic",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Canvas/ Cotton",
      "Color Category": "Whites & Neutrals",
    },
    {
      "Part #": "FAB201768",
      "Fabric Name/Color": "Oxford Sage",
      Grade: "Basic",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Jaquard",
      "Color Category": "Greens & Yellows",
    },
    {
      "Part #": "FAB201054",
      "Fabric Name/Color": "Pabon Brass",
      Grade: "Accent/Pillow",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Pattern",
      "Material Type": "Jacquard",
      "Color Category": "Greens & Yellows",
    },
    {
      "Part #": "FAB201192",
      "Fabric Name/Color": "Pabon Domino",
      Grade: "Accent/Pillow",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Pattern",
      "Material Type": "Jacquard",
      "Color Category": "Blacks & Purples",
    },
    {
      "Part #": "FAB102041",
      "Fabric Name/Color": "Palm Mist Mica",
      Grade: "Accent/Pillow",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Pattern",
      "Material Type": "Chenille",
      "Color Category": "Browns",
    },
    {
      "Part #": "FAB102043",
      "Fabric Name/Color": "Pannier Pottery",
      Grade: "Accent/Pillow",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Pattern",
      "Material Type": "Jacquard",
      "Color Category": "Pink, Red, & Orange",
    },
    {
      "Part #": "FAB102045",
      "Fabric Name/Color": "Parallel Charcoal",
      Grade: "Basic",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Woven Texture",
      "Color Category": "Greys & Charcoal",
    },
    {
      "Part #": "FAB102046",
      "Fabric Name/Color": "Parallel Dove",
      Grade: "Basic",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Woven Texture",
      "Color Category": "Greys & Charcoal",
    },
    {
      "Part #": "FAB200522",
      "Fabric Name/Color": "Parallel Paprika",
      Grade: "Basic",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Chenille",
      "Color Category": "Pink, Red, & Orange",
    },
    {
      "Part #": "FAB102049",
      "Fabric Name/Color": "Parallel Stone",
      Grade: "Basic",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Woven Texture",
      "Color Category": "Greys & Charcoal",
    },
    {
      "Part #": "FAB200523",
      "Fabric Name/Color": "Parallel Tobacco",
      Grade: "Basic",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Chenille",
      "Color Category": "Pink, Red, & Orange",
    },
    {
      "Part #": "FAB201723",
      "Fabric Name/Color": "Parks Jade",
      Grade: "Premium C",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Linen Look",
      "Color Category": "Blues",
    },
    {
      "Part #": "FAB201463",
      "Fabric Name/Color": "Pax Canvas",
      Grade: "Accent/Pillow",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Pattern",
      "Material Type": "Woven Texture",
      "Color Category": "Whites & Neutrals",
    },
    {
      "Part #": "FAB102057",
      "Fabric Name/Color": "Pearl Leopard Snuggle",
      Grade: "Accent/Pillow",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Pattern",
      "Material Type": "Faux Fur",
      "Color Category": "Whites & Neutrals",
    },
    {
      "Part #": "FAB201747",
      "Fabric Name/Color": "Peaslee Bark",
      Grade: "Accent",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Pattern",
      "Material Type": "Woven Texture",
      "Color Category": "Browns",
    },
    {
      "Part #": "FAB102068",
      "Fabric Name/Color": "Peyton Navy",
      Grade: "Basic",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Canvas/Cotton",
      "Color Category": "Blues",
    },
    {
      "Part #": "FAB102069",
      "Fabric Name/Color": "Peyton Pearl",
      Grade: "Basic",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Canvas/Cotton",
      "Color Category": "Whites & Neutrals",
    },
    {
      "Part #": "FAB102070",
      "Fabric Name/Color": "Peyton Pepper",
      Grade: "Basic",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Canvas/Cotton",
      "Color Category": "Blacks & Purples",
    },
    {
      "Part #": "FAB102072",
      "Fabric Name/Color": "Peyton Slate",
      Grade: "Basic",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Canvas/Cotton",
      "Color Category": "Greys & Charcoal",
    },
    {
      "Part #": "FAB201116",
      "Fabric Name/Color": "Pierina Pool",
      Grade: "Accent/Pillow",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Pattern",
      "Material Type": "Jacquard",
      "Color Category": "Blues",
    },
    {
      "Part #": "FAB200131",
      "Fabric Name/Color": "Pirelli Asphalt",
      Grade: "Accent/Pillow",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Pattern",
      "Material Type": "Chenille",
      "Color Category": "Blacks & Purples",
    },
    {
      "Part #": "FAB201231",
      "Fabric Name/Color": "Pixie Natural",
      Grade: "Accent/Pillow",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Faux Fur",
      "Color Category": "Whites & Neutrals",
    },
    {
      "Part #": "FAB102085",
      "Fabric Name/Color": "Plaything Pewter",
      Grade: "Accent/Pillow",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Pattern",
      "Material Type": "Chenille",
      "Color Category": "Whites & Neutrals",
    },
    {
      "Part #": "FAB200958",
      "Fabric Name/Color": "Pleat Coconut",
      Grade: "Accent/Pillow",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Pattern",
      "Material Type": "Faux Fur",
      "Color Category": "Whites & Neutrals",
    },
    {
      "Part #": "FAB102110",
      "Fabric Name/Color": "Premiere Stone",
      Grade: "Premium B",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Velvet",
      "Color Category": "Whites & Neutrals",
    },
    {
      "Part #": "FAB201619",
      "Fabric Name/Color": "Punch Line Linen",
      Grade: "Accent/Pillow",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Pattern",
      "Material Type": "Woven Texture",
      "Color Category": "Blues",
    },
    {
      "Part #": "FAB201562",
      "Fabric Name/Color": "Queen Bey Celadon",
      Grade: "Basic",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Woven Texture",
      "Color Category": "Blues",
    },
    {
      "Part #": "FAB201563",
      "Fabric Name/Color": "Queen Bey Cypress",
      Grade: "Basic",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Woven Texture",
      "Color Category": "Greens & Yellows",
    },
    {
      "Part #": "FAB201554",
      "Fabric Name/Color": "Queen Bey Daffodil",
      Grade: "Basic",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Woven Texture",
      "Color Category": "Greens & Yellows",
    },
    {
      "Part #": "FAB201553",
      "Fabric Name/Color": "Queen Bey Flax",
      Grade: "Basic",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Woven Texture",
      "Color Category": "Greys & Charcoals",
    },
    {
      "Part #": "FAB200043",
      "Fabric Name/Color": "Raji Indigo",
      Grade: "Accent/Pillow",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Pattern",
      "Material Type": "Jacquard",
      "Color Category": "Blues",
    },
    {
      "Part #": "LEA100077",
      "Fabric Name/Color": "Raven Bay Blue",
      Grade: "Top Grain Leather",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Leather",
      "Color Category": "Blues",
    },
    {
      "Part #": "FAB201845",
      "Fabric Name/Color": "Razzle Cassia",
      Grade: "Basic",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Woven Texture",
      "Color Category": "Pink, Red, & Orange",
    },
    {
      "Part #": "FAB200363",
      "Fabric Name/Color": "Reason Greystone",
      Grade: "Accent/Pillow",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Pattern",
      "Material Type": "Jacquard",
      "Color Category": "Whites & Neutrals",
    },
    {
      "Part #": "FAB201481",
      "Fabric Name/Color": "Renew Dawn",
      Grade: "Accent/Pillow",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Pattern",
      "Material Type": "Print",
      "Color Category": "Blues",
    },
    {
      "Part #": "FAB201060",
      "Fabric Name/Color": "Ric Rac Patina",
      Grade: "Accent/Pillow",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Pattern",
      "Material Type": "Jacquard",
      "Color Category": "Browns",
    },
    {
      "Part #": "FAB200086",
      "Fabric Name/Color": "Riddle Pewter",
      Grade: "Accent/Pillow",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Pattern",
      "Material Type": "Chenille",
      "Color Category": "Browns",
    },
    {
      "Part #": "FAB200355",
      "Fabric Name/Color": "Rizzo Almond",
      Grade: "Accent/Pillow",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Pattern",
      "Material Type": "Chenille",
      "Color Category": "Whites & Neutrals",
    },
    {
      "Part #": "FAB201634",
      "Fabric Name/Color": "Rodin Alabaster",
      Grade: "Accent/Pillow",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Pattern",
      "Material Type": "Woven Texture",
      "Color Category": "Whites & Neutrals",
    },
    {
      "Part #": "FAB201297",
      "Fabric Name/Color": "Rodman Amber",
      Grade: "Accent/Pillow",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Pattern",
      "Material Type": "Woven Texture",
      "Color Category": "Browns",
    },
    {
      "Part #": "FAB201306",
      "Fabric Name/Color": "Rodman Lagoon",
      Grade: "Accent/Pillow",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Pattern",
      "Material Type": "Woven Texture",
      "Color Category": "Blues",
    },
    {
      "Part #": "FAB201700",
      "Fabric Name/Color": "Rowdy Clay",
      Grade: "Basic",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Woven Texture",
      "Color Category": "Whites & Neutrals",
    },
    {
      "Part #": "FAB200284",
      "Fabric Name/Color": "Royale Ash",
      Grade: "Basic",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Velvet",
      "Color Category": "Greys & Charcoal",
    },
    {
      "Part #": "FAB102167",
      "Fabric Name/Color": "Royale Blush",
      Grade: "Basic",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Velvet",
      "Color Category": "Pink, Red, & Orange",
    },
    {
      "Part #": "FAB200285",
      "Fabric Name/Color": "Royale Cobalt",
      Grade: "Basic",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Velvet",
      "Color Category": "Blues",
    },
    {
      "Part #": "FAB200471",
      "Fabric Name/Color": "Royale Coral",
      Grade: "Basic",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Velvet",
      "Color Category": "Pink, Red, & Orange",
    },
    {
      "Part #": "FAB200443",
      "Fabric Name/Color": "Royale Dijon",
      Grade: "Basic",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Velvet",
      "Color Category": "Greens & Yellows",
    },
    {
      "Part #": "FAB102168",
      "Fabric Name/Color": "Royale Evergreen",
      Grade: "Basic",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Velvet",
      "Color Category": "Greens & Yellows",
    },
    {
      "Part #": "FAB200287",
      "Fabric Name/Color": "Royale Gunmetal",
      Grade: "Basic",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Velvet",
      "Color Category": "Blacks & Purples",
    },
    {
      "Part #": "FAB200238",
      "Fabric Name/Color": "Royale Mondo",
      Grade: "Basic",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Velvet",
      "Color Category": "Whites & Neutrals",
    },
    {
      "Part #": "FAB200288",
      "Fabric Name/Color": "Royale Peacock",
      Grade: "Basic",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Velvet",
      "Color Category": "Greys & Charcoal",
    },
    {
      "Part #": "FAB102174",
      "Fabric Name/Color": "Sabira Cobalt",
      Grade: "Accent/Pillow",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Pattern",
      "Material Type": "Chenille",
      "Color Category": "Blues",
    },
    {
      "Part #": "FAB201692",
      "Fabric Name/Color": "Sahara Rust",
      Grade: "Accent/Pillow",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Pattern",
      "Material Type": "Woven Texture",
      "Color Category": "Pinks, Reds, Oranges",
    },
    {
      "Part #": "FAB201469",
      "Fabric Name/Color": "San Marco Pewter",
      Grade: "Accent/Pillow",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Pattern",
      "Material Type": "Print",
      "Color Category": "Blues",
    },
    {
      "Part #": "FAB201552",
      "Fabric Name/Color": "Santorini Laurel",
      Grade: "Accent/Pillow",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Pattern",
      "Material Type": "Woven Texture",
      "Color Category": "Greens & Yellows",
    },
    {
      "Part #": "FAB201477",
      "Fabric Name/Color": "Saruri Mist",
      Grade: "Accent/Pillow",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Pattern",
      "Material Type": "Jaquard",
      "Color Category": "Blues",
    },
    {
      "Part #": "FAB201199",
      "Fabric Name/Color": "Satillo Driftwood",
      Grade: "Accent/Pillow",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Pattern",
      "Material Type": "Jacquard",
      "Color Category": "Greys & Charcoals",
    },
    {
      "Part #": "FAB201712",
      "Fabric Name/Color": "Saverio Jungle",
      Grade: "Accent/Pillow",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Pattern",
      "Material Type": "Jaquard",
      "Color Category": "Blues",
    },
    {
      "Part #": "FAB102208",
      "Fabric Name/Color": "Scribble Indigo",
      Grade: "Accent/Pillow",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Pattern",
      "Material Type": "Woven Texture",
      "Color Category": "Blues",
    },
    {
      "Part #": "FAB102210",
      "Fabric Name/Color": "Scripps Kona",
      Grade: "Accent/Pillow",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Pattern",
      "Material Type": "Woven Texture",
      "Color Category": "Greys & Charcoal",
    },
    {
      "Part #": "FAB102212",
      "Fabric Name/Color": "Seismic Driftwood",
      Grade: "Accent/Pillow",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Pattern",
      "Material Type": "Jacquard",
      "Color Category": "Whites & Neutrals",
    },
    {
      "Part #": "FAB102219",
      "Fabric Name/Color": "Sensu Flax",
      Grade: "Basic",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Linen Look",
      "Color Category": "Whites & Neutrals",
    },
    {
      "Part #": "FAB201223",
      "Fabric Name/Color": "Shapan Ink",
      Grade: "Accent/Pillow",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Pattern",
      "Material Type": "Jacquard",
      "Color Category": "Blues",
    },
    {
      "Part #": "FAB200089",
      "Fabric Name/Color": "Sheepskin Natural",
      Grade: "Accent/Pillow",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Pattern",
      "Material Type": "Faux Fur",
      "Color Category": "Whites & Neutrals",
    },
    {
      "Part #": "FAB200989",
      "Fabric Name/Color": "Sheepskin Toast",
      Grade: "Accent/Pillow",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Pattern",
      "Material Type": "Faux Fur",
      "Color Category": "Whites & Neutrals",
    },
    {
      "Part #": "FAB201628",
      "Fabric Name/Color": "Shinedown Fresco",
      Grade: "Accent/Pillow",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Pattern",
      "Material Type": "Jaquard",
      "Color Category": "Pinks, Reds, Oranges",
    },
    {
      "Part #": "FAB201476",
      "Fabric Name/Color": "Sidetracks Coconut",
      Grade: "Accent/Pillow",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Pattern",
      "Material Type": "Jaquard",
      "Color Category": "Whites & Neutrals",
    },
    {
      "Part #": "FAB200376",
      "Fabric Name/Color": "Sinatra Fiddlefern",
      Grade: "Accent/Pillow",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Pattern",
      "Material Type": "Velvet",
      "Color Category": "Greens & Yellows",
    },
    {
      "Part #": "FAB201338",
      "Fabric Name/Color": "Skoog Dove",
      Grade: "Accent/Pillow",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Pattern",
      "Material Type": "Jaquard",
      "Color Category": "Whites & Neutrals",
    },
    {
      "Part #": "FAB200981",
      "Fabric Name/Color": "Souffle Aqua",
      Grade: "Accent/Pillow",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Pattern",
      "Material Type": "Jacquard",
      "Color Category": "Blues",
    },
    {
      "Part #": "FAB200743",
      "Fabric Name/Color": "Spectra Hot Stone",
      Grade: "Basic",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Chenille",
      "Color Category": "Greys & Charcoal",
    },
    {
      "Part #": "FAB200742",
      "Fabric Name/Color": "Spectra Rainfall",
      Grade: "Basic",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Chenille",
      "Color Category": "Blues",
    },
    {
      "Part #": "FAB200744",
      "Fabric Name/Color": "Spectra Yogi",
      Grade: "Basic",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Chenille",
      "Color Category": "Greys & Charcoal",
    },
    {
      "Part #": "FAB102294",
      "Fabric Name/Color": "Speedway Marine",
      Grade: "Accent/Pillow",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Pattern",
      "Material Type": "Jacquard",
      "Color Category": "Blues",
    },
    {
      "Part #": "FAB201196",
      "Fabric Name/Color": "Splendour Desert Dune",
      Grade: "Premium B",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Chenille",
      "Color Category": "Whites & Neutrals",
    },
    {
      "Part #": "FAB201544",
      "Fabric Name/Color": "Striker Copper",
      Grade: "Accent/Pillow",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Pattern",
      "Material Type": "Woven Texture",
      "Color Category": "Greens & Yellows",
    },
    {
      "Part #": "FAB200090",
      "Fabric Name/Color": "Strummer Denim",
      Grade: "Accent/Pillow",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Pattern",
      "Material Type": "Jacquard",
      "Color Category": "Blues",
    },
    {
      "Part #": "FAB201790",
      "Fabric Name/Color": "Sugarshack Charcoal",
      Grade: "Basic",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Woven Texture",
      "Color Category": "Greys & Charcoals",
    },
    {
      "Part #": "FAB201792",
      "Fabric Name/Color": "Sugarshack Pebble",
      Grade: "Basic",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Woven Texture",
      "Color Category": "Whites & Neutrals",
    },
    {
      "Part #": "FAB201367",
      "Fabric Name/Color": "Swardson Stone",
      Grade: "Accent/Pillow",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Pattern",
      "Material Type": "Woven Texture",
      "Color Category": "Blacks & Purples",
    },
    {
      "Part #": "FAB200368",
      "Fabric Name/Color": "Sweater Desert",
      Grade: "Basic",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Woven Texture",
      "Color Category": "Browns",
    },
    {
      "Part #": "FAB200369",
      "Fabric Name/Color": "Sweater Silver",
      Grade: "Basic",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Woven Texture",
      "Color Category": "Browns",
    },
    {
      "Part #": "FAB201779",
      "Fabric Name/Color": "Sylvie Charcoal",
      Grade: "Basic",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Jaquard",
      "Color Category": "Blacks & Purples",
    },
    {
      "Part #": "FAB201837",
      "Fabric Name/Color": "Sylvie Olive",
      Grade: "Basic",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Woven Texture",
      "Color Category": "Blacks & Purples",
    },
    {
      "Part #": "FAB102349",
      "Fabric Name/Color": "Symba Onyx",
      Grade: "Accent/Pillow",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Pattern",
      "Material Type": "Jacquard",
      "Color Category": "Blacks & Purples",
    },
    {
      "Part #": "FAB200366",
      "Fabric Name/Color": "Synergy Charcoal",
      Grade: "Basic",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Chenille",
      "Color Category": "Blacks & Purples",
    },
    {
      "Part #": "fab201466",
      "Fabric Name/Color": "Talia Cream",
      Grade: "Basic",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Chenille",
      "Color Category": "Whites & Neutrals",
    },
    {
      "Part #": "FAB201635",
      "Fabric Name/Color": "Talia Glacier",
      Grade: "Basic",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Chenille",
      "Color Category": "Blues",
    },
    {
      "Part #": "FAB200014",
      "Fabric Name/Color": "Tally Capri",
      Grade: "Accent/Pillow",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Pattern",
      "Material Type": "Woven Texture",
      "Color Category": "Blues",
    },
    {
      "Part #": "FAB102379",
      "Fabric Name/Color": "Taylor Felt Grey",
      Grade: "Basic",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Woven Texture",
      "Color Category": "Greys & Charcoal",
    },
    {
      "Part #": "FAB102380",
      "Fabric Name/Color": "Tech Arctic",
      Grade: "Basic",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Woven Texture",
      "Color Category": "Whites & Neutrals",
    },
    {
      "Part #": "FAB102381",
      "Fabric Name/Color": "Tech Brownstone",
      Grade: "Basic",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Woven Texture",
      "Color Category": "Browns",
    },
    {
      "Part #": "FAB102382",
      "Fabric Name/Color": "Tech Granite",
      Grade: "Basic",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Woven Texture",
      "Color Category": "Greys & Charcoal",
    },
    {
      "Part #": "FAB102383",
      "Fabric Name/Color": "Tech Oak",
      Grade: "Basic",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Woven Texture",
      "Color Category": "Greys & Charcoal",
    },
    {
      "Part #": "FAB102384",
      "Fabric Name/Color": "Tech Pebble",
      Grade: "Basic",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Woven Texture",
      "Color Category": "Greys & Charcoal",
    },
    {
      "Part #": "FAB102385",
      "Fabric Name/Color": "Tech Stone",
      Grade: "Basic",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Woven Texture",
      "Color Category": "Browns",
    },
    {
      "Part #": "FAB200162",
      "Fabric Name/Color": "Ted Charcoal",
      Grade: "Basic",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Woven Texture",
      "Color Category": "Greys & Charcoal",
    },
    {
      "Part #": "FAB200163",
      "Fabric Name/Color": "Ted Fog",
      Grade: "Basic",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Chenille",
      "Color Category": "Greys & Charcoal",
    },
    {
      "Part #": "FAB200351",
      "Fabric Name/Color": "Ted Metal",
      Grade: "Basic",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Chenille",
      "Color Category": "Greys & Charcoal",
    },
    {
      "Part #": "FAB200164",
      "Fabric Name/Color": "Ted Navy",
      Grade: "Basic",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Chenille",
      "Color Category": "Blues",
    },
    {
      "Part #": "FAB201203",
      "Fabric Name/Color": "Terrain Lichen",
      Grade: "Accent/Pillow",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Pattern",
      "Material Type": "Jacquard",
      "Color Category": "Greens & Yellows",
    },
    {
      "Part #": "FAB200018",
      "Fabric Name/Color": "Thrillist Denim",
      Grade: "Basic",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Linen Look",
      "Color Category": "Blues",
    },
    {
      "Part #": "FAB200098",
      "Fabric Name/Color": "Thrillist Fog",
      Grade: "Basic",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Linen Look",
      "Color Category": "Greys & Charcoal",
    },
    {
      "Part #": "FAB200099",
      "Fabric Name/Color": "Thrillist Graphite",
      Grade: "Basic",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Linen Look",
      "Color Category": "Greys & Charcoal",
    },
    {
      "Part #": "FAB200100",
      "Fabric Name/Color": "Thrillist Parchment",
      Grade: "Basic",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Linen Look",
      "Color Category": "Whites & Neutrals",
    },
    {
      "Part #": "FAB200140",
      "Fabric Name/Color": "Thrillist Pearl",
      Grade: "Basic",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Linen Look",
      "Color Category": "Whites & Neutrals",
    },
    {
      "Part #": "FAB200101",
      "Fabric Name/Color": "Thrillist Twig",
      Grade: "Basic",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Linen Look",
      "Color Category": "Browns",
    },
    {
      "Part #": "FAB201057",
      "Fabric Name/Color": "Tika Jade",
      Grade: "Accent/Pillow",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Pattern",
      "Material Type": "Velvet",
      "Color Category": "Greens & Yellows",
    },
    {
      "Part #": "FAB201453",
      "Fabric Name/Color": "Tildan Almond",
      Grade: "Basic",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Chenille",
      "Color Category": "Whites & Neutrals",
    },
    {
      "Part #": "FAB201455",
      "Fabric Name/Color": "Tildan Oatmeal",
      Grade: "Basic",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Chenille",
      "Color Category": "Greys & Charcoals",
    },
    {
      "Part #": "FAB201456",
      "Fabric Name/Color": "Tildan Saddle",
      Grade: "Basic",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Chenille",
      "Color Category": "Browns",
    },
    {
      "Part #": "FAB201454",
      "Fabric Name/Color": "Tildan Seafoam",
      Grade: "Basic",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Chenille",
      "Color Category": "Blues",
    },
    {
      "Part #": "FAB102402",
      "Fabric Name/Color": "Timbuktu Canyon",
      Grade: "Accent/Pillow",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Pattern",
      "Material Type": "Woven Texture",
      "Color Category": "Browns",
    },
    {
      "Part #": "FAB102403",
      "Fabric Name/Color": "Time Square Harbour",
      Grade: "Accent/Pillow",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Pattern",
      "Material Type": "Velvet",
      "Color Category": "Blues",
    },
    {
      "Part #": "FAB201633",
      "Fabric Name/Color": "Tira Inlet",
      Grade: "Basic",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Pattern",
      "Material Type": "Woven Texture",
      "Color Category": "Blues",
    },
    {
      "Part #": "FAB201719",
      "Fabric Name/Color": "Toscana Olive",
      Grade: "Basic",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Velvet",
      "Color Category": "Greens & Yellows",
    },
    {
      "Part #": "FAB201781",
      "Fabric Name/Color": "Trailhead Celestial",
      Grade: "Accent",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Pattern",
      "Material Type": "Jaquard",
      "Color Category": "Blues",
    },
    {
      "Part #": "FAB201225",
      "Fabric Name/Color": "Tramore Amaretto",
      Grade: "Basic",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Woven Texture",
      "Color Category": "Browns",
    },
    {
      "Part #": "FAB201533",
      "Fabric Name/Color": "Tramore Bisque",
      Grade: "Basic",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Woven Texture",
      "Color Category": "Whites & Neutrals",
    },
    {
      "Part #": "FAB201549",
      "Fabric Name/Color": "Tramore Evening",
      Grade: "Basic",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Woven Texture",
      "Color Category": "Blues",
    },
    {
      "Part #": "FAB201560",
      "Fabric Name/Color": "Tramore Minted",
      Grade: "Basic",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Woven Texture",
      "Color Category": "Blues",
    },
    {
      "Part #": "FAB201561",
      "Fabric Name/Color": "Tramore Sedona",
      Grade: "Basic",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Woven Texture",
      "Color Category": "Pinks, Reds, Oranges",
    },
    {
      "Part #": "FAB201532",
      "Fabric Name/Color": "Tramore Sienna",
      Grade: "Basic",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Woven Texture",
      "Color Category": "Browns",
    },
    {
      "Part #": "LEA100085",
      "Fabric Name/Color": "Tribeca Chelsea",
      Grade: "Top Grain Leather",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Leather",
      "Color Category": "Browns",
    },
    {
      "Part #": "LEA100093",
      "Fabric Name/Color": "Tribeca Oyster",
      Grade: "Top Grain Leather",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Leather",
      "Color Category": "Whites & Neutrals",
    },
    {
      "Part #": "FAB102417",
      "Fabric Name/Color": "Trinity Fog",
      Grade: "Accent/Pillow",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Pattern",
      "Material Type": "Jacquard",
      "Color Category": "Greys & Charcoal",
    },
    {
      "Part #": "FAB102419",
      "Fabric Name/Color": "Tropicana Coastal",
      Grade: "Accent/Pillow",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Pattern",
      "Material Type": "Jacquard",
      "Color Category": "Greens & Yellows",
    },
    {
      "Part #": "LEA100078",
      "Fabric Name/Color": "Tuscany Fawn",
      Grade: "Top Grain Leather",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Leather",
      "Color Category": "Browns",
    },
    {
      "Part #": "FAB201484",
      "Fabric Name/Color": "Ullman Desert",
      Grade: "Accent/Pillow",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Pattern",
      "Material Type": "Jaquard",
      "Color Category": "Pinks, Reds, Oranges",
    },
    {
      "Part #": "FAB201531",
      "Fabric Name/Color": "Ullman Vanilla",
      Grade: "Accent/Pillow",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Pattern",
      "Material Type": "Jaquard",
      "Color Category": "Whites & Neutrals",
    },
    {
      "Part #": "FAB201744",
      "Fabric Name/Color": "Uninvited Stone",
      Grade: "Accent",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Pattern",
      "Material Type": "Woven Texture",
      "Color Category": "Greys & Charcoal",
    },
    {
      "Part #": "FAB201230",
      "Fabric Name/Color": "Utopia Sand",
      Grade: "Basic",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Faux Fur",
      "Color Category": "Whites & Neutrals",
    },
    {
      "Part #": "FAB201479",
      "Fabric Name/Color": "Vacarello Indigo",
      Grade: "Accent/Pillow",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Pattern",
      "Material Type": "Jaquard",
      "Color Category": "Blues",
    },
    {
      "Part #": "FAB201748",
      "Fabric Name/Color": "Vanishing Coconut",
      Grade: "Accent",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Pattern",
      "Material Type": "Woven Texture",
      "Color Category": "Whites & Neutrals",
    },
    {
      "Part #": "FAB102450",
      "Fabric Name/Color": "Verona Ecru",
      Grade: "Premium A",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Woven Texture",
      "Color Category": "Greys & Charcoal",
    },
    {
      "Part #": "FAB102451",
      "Fabric Name/Color": "Verona Silver",
      Grade: "Premium A",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Woven Texture",
      "Color Category": "Greys & Charcoal",
    },
    {
      "Part #": "FAB102458",
      "Fabric Name/Color": "Vibe Nocturnal",
      Grade: "Basic",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Woven Texture",
      "Color Category": "Blacks & Purples",
    },
    {
      "Part #": "FAB102461",
      "Fabric Name/Color": "Vibe Solitude",
      Grade: "Basic",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Woven Texture",
      "Color Category": "Blues",
    },
    {
      "Part #": "FAB102463",
      "Fabric Name/Color": "Vibe Tranquil",
      Grade: "Basic",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Woven Texture",
      "Color Category": "Blues",
    },
    {
      "Part #": "FAB102465",
      "Fabric Name/Color": "Vibe Zest",
      Grade: "Basic",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Woven Texture",
      "Color Category": "Greens & Yellows",
    },
    {
      "Part #": "FAB102468",
      "Fabric Name/Color": "Victory Ivory",
      Grade: "Basic",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Woven Texture",
      "Color Category": "Whites & Neutrals",
    },
    {
      "Part #": "FAB201194",
      "Fabric Name/Color": "Vosburgh Pearl",
      Grade: "Accent/Pillow",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Pattern",
      "Material Type": "Jacquard",
      "Color Category": "Whites & Neutrals",
    },
    {
      "Part #": "FAB200435",
      "Fabric Name/Color": "Waka Waka Cocoa",
      Grade: "Accent/Pillow",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Pattern",
      "Material Type": "Woven Texture",
      "Color Category": "Browns",
    },
    {
      "Part #": "FAB102483",
      "Fabric Name/Color": "Weston Gull",
      Grade: "Basic",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Chenille",
      "Color Category": "Browns",
    },
    {
      "Part #": "FAB201846",
      "Fabric Name/Color": "Whisper Clay",
      Grade: "Basic",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Linen Look",
      "Color Category": "Pink, Red, & Orange",
    },
    {
      "Part #": "FAB201848",
      "Fabric Name/Color": "Whisper Cloud",
      Grade: "Basic",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Linen Look",
      "Color Category": "Pink, Red, & Orange",
    },
    {
      "Part #": "FAB201847",
      "Fabric Name/Color": "Whisper Yuzu",
      Grade: "Basic",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Linen Look",
      "Color Category": "Pink, Red, & Orange",
    },
    {
      "Part #": "FAB102532",
      "Fabric Name/Color": "Wilshire Pepper",
      Grade: "Basic",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Chenille",
      "Color Category": "Greys & Charcoal",
    },
    {
      "Part #": "LEA100090",
      "Fabric Name/Color": "Winchester Balsam",
      Grade: "Top Grain Leather",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Leather",
      "Color Category": "Greens & Yellows",
    },
    {
      "Part #": "FAB200440",
      "Fabric Name/Color": "Winding Ivory",
      Grade: "Accent/Pillow",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Pattern",
      "Material Type": "Velvet",
      "Color Category": "Whites & Neutrals",
    },
    {
      "Part #": "FAB102487",
      "Fabric Name/Color": "Woofit Quartz",
      Grade: "Accent/Pillow",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Pattern",
      "Material Type": "Woven Texture",
      "Color Category": "Whites & Neutrals",
    },
    {
      "Part #": "FAB201841",
      "Fabric Name/Color": "Yakety Yak Sand",
      Grade: "Accent/Pillow",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Faux Fur",
      "Color Category": "Whites & Neutrals",
    },
    {
      "Part #": "FAB200944",
      "Fabric Name/Color": "Yang Blush",
      Grade: "Accent/Pillow",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Pattern",
      "Material Type": "Woven Texture",
      "Color Category": "Pink, Red, & Orange",
    },
    {
      "Part #": "FAB102497",
      "Fabric Name/Color": "Zain Dusk",
      Grade: "Accent/Pillow",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Pattern",
      "Material Type": "Woven Texture",
      "Color Category": "Blues",
    },
    {
      "Part #": "FAB201550",
      "Fabric Name/Color": "Zayden Honey",
      Grade: "Basic",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Woven Texture",
      "Color Category": "Browns",
    },
    {
      "Part #": "FAB201545",
      "Fabric Name/Color": "Zayden Olive",
      Grade: "Basic",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Woven Texture",
      "Color Category": "Greens & Yellows",
    },
    {
      "Part #": "FAB201016",
      "Fabric Name/Color": "Zaza Graphite",
      Grade: "Accent/Pillow",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Pattern",
      "Material Type": "Jacquard",
      "Color Category": "Blacks & Purples",
    },
    {
      "Part #": "FAB200452",
      "Fabric Name/Color": "Zeffa Flax",
      Grade: "Accent/Pillow",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Pattern",
      "Material Type": "Woven Texture",
      "Color Category": "Whites & Neutrals",
    },
    {
      "Part #": "FAB201625",
      "Fabric Name/Color": "Zendejas Moss",
      Grade: "Accent/Pillow",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Pattern",
      "Material Type": "Jaquard",
      "Color Category": "Greens & Yellows",
    },
    {
      "Part #": "FAB201228",
      "Fabric Name/Color": "Zeus Pearl",
      Grade: "Basic",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Woven Texture",
      "Color Category": "Whites & Neutrals",
    },
    {
      "Part #": "FAB201229",
      "Fabric Name/Color": "Zeus Silver",
      Grade: "Basic",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Woven Texture",
      "Color Category": "Greys & Charcoals",
    },
    {
      "Part #": "FAB201624",
      "Fabric Name/Color": "Zingman Beach",
      Grade: "Accent/Pillow",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Pattern",
      "Material Type": "Jaquard",
      "Color Category": "Whites & Neutrals",
    },
    {
      "Part #": "FAB201211",
      "Fabric Name/Color": "Zion Charcoal",
      Grade: "Basic",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Woven Texture",
      "Color Category": "Greys & Charcoal",
    },
    {
      "Part #": "FAB201209",
      "Fabric Name/Color": "Zion Forest",
      Grade: "Basic",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Woven Texture",
      "Color Category": "Greens & Yellows",
    },
    {
      "Part #": "FAB201208",
      "Fabric Name/Color": "Zion Khaki",
      Grade: "Basic",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Woven Texture",
      "Color Category": "Whites & Neutrals",
    },
    {
      "Part #": "FAB201210",
      "Fabric Name/Color": "Zion Marine",
      Grade: "Basic",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Woven Texture",
      "Color Category": "Blues",
    },
    {
      "Part #": "FAB201299",
      "Fabric Name/Color": "Zion Stone",
      Grade: "Basic",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Woven Texture",
      "Color Category": "Greys & Charcoal",
    },
    {
      "Part #": "FAB200342",
      "Fabric Name/Color": "Zuri Fog",
      Grade: "Basic",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Woven Texture",
      "Color Category": "Browns",
    },
    {
      "Part #": "FAB200340",
      "Fabric Name/Color": "Zuri Mist",
      Grade: "Basic",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Woven Texture",
      "Color Category": "Browns",
    },
    {
      "Part #": "FAB200341",
      "Fabric Name/Color": "Zuri Natural",
      Grade: "Basic",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Woven Texture",
      "Color Category": "Browns",
    },
    {
      "Part #": "FAB200330",
      "Fabric Name/Color": "Zuri Pewter",
      Grade: "Basic",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Woven Texture",
      "Color Category": "Greys & Charcoal",
    },
    {
      "Part #": "FAB200329",
      "Fabric Name/Color": "Zuri Stone",
      Grade: "Basic",
      "JL Upholstery": "JL Upholstery",
      "Solid or Pattern": "Solid",
      "Material Type": "Woven Texture",
      "Color Category": "Greys & Charcoal",
    },
    {
      "Part #": "FAB201803",
      "Fabric Name/Color": "ARTEMIS BISQUE",
      Grade: "Premium C",
      "JL Upholstery": "JL Catalog - Crypton",
      "Solid or Pattern": "Solid",
      "Material Type": "Velvet",
      "Color Category": "Whites & Neutrals",
    },
    {
      "Part #": "FAB201804",
      "Fabric Name/Color": "ARTEMIS MOSS",
      Grade: "Premium C",
      "JL Upholstery": "JL Catalog - Crypton",
      "Solid or Pattern": "Solid",
      "Material Type": "Velvet",
      "Color Category": "Greens & Yellows",
    },
    {
      "Part #": "FAB201807",
      "Fabric Name/Color": "ARTEMIS PRUSSIAN",
      Grade: "Premium C",
      "JL Upholstery": "JL Catalog - Crypton",
      "Solid or Pattern": "Solid",
      "Material Type": "Velvet",
      "Color Category": "Blues",
    },
    {
      "Part #": "FAB201805",
      "Fabric Name/Color": "ARTEMIS VICUNA",
      Grade: "Premium C",
      "JL Upholstery": "JL Catalog - Crypton",
      "Solid or Pattern": "Solid",
      "Material Type": "Velvet",
      "Color Category": "Whites & Neutrals",
    },
    {
      "Part #": "FAB201806",
      "Fabric Name/Color": "ARTEMIS WOODROSE",
      Grade: "Premium C",
      "JL Upholstery": "JL Catalog - Crypton",
      "Solid or Pattern": "Solid",
      "Material Type": "Velvet",
      "Color Category": "Pink, Red, & Orange",
    },
    {
      "Part #": "FAB201809",
      "Fabric Name/Color": "BEDFORD CUSTARD",
      Grade: "Premium C",
      "JL Upholstery": "JL Catalog - Crypton",
      "Solid or Pattern": "Solid",
      "Material Type": "Woven Texture",
      "Color Category": "Whites & Neutrals",
    },
    {
      "Part #": "FAB201808",
      "Fabric Name/Color": "BEDFORD SNOW",
      Grade: "Premium C",
      "JL Upholstery": "JL Catalog - Crypton",
      "Solid or Pattern": "Solid",
      "Material Type": "Woven Texture",
      "Color Category": "Whites & Neutrals",
    },
    {
      "Part #": "FAB201812",
      "Fabric Name/Color": "BENOIT COPPER",
      Grade: "Premium B",
      "JL Upholstery": "JL Catalog - Crypton",
      "Solid or Pattern": "Solid",
      "Material Type": "Woven Texture",
      "Color Category": "Browns",
    },
    {
      "Part #": "FAB201811",
      "Fabric Name/Color": "BENOIT HEMP",
      Grade: "Premium B",
      "JL Upholstery": "JL Catalog - Crypton",
      "Solid or Pattern": "Solid",
      "Material Type": "Woven Texture",
      "Color Category": "Whites & Neutrals",
    },
    {
      "Part #": "FAB201813",
      "Fabric Name/Color": "BENOIT INDIGO",
      Grade: "Premium B",
      "JL Upholstery": "JL Catalog - Crypton",
      "Solid or Pattern": "Solid",
      "Material Type": "Woven Texture",
      "Color Category": "Blues",
    },
    {
      "Part #": "FAB201810",
      "Fabric Name/Color": "BENOIT LINEN",
      Grade: "Premium B",
      "JL Upholstery": "JL Catalog - Crypton",
      "Solid or Pattern": "Solid",
      "Material Type": "Woven Texture",
      "Color Category": "Whites & Neutrals",
    },
    {
      "Part #": "FAB201814",
      "Fabric Name/Color": "BENOIT TOURMALINE",
      Grade: "Premium B",
      "JL Upholstery": "JL Catalog - Crypton",
      "Solid or Pattern": "Solid",
      "Material Type": "Woven Texture",
      "Color Category": "Blues",
    },
    {
      "Part #": "FAB201825",
      "Fabric Name/Color": "JENNIE LINEN",
      Grade: "Premium C",
      "JL Upholstery": "JL Catalog - Crypton",
      "Solid or Pattern": "Solid",
      "Material Type": "Chenille",
      "Color Category": "Whites & Neutrals",
    },
    {
      "Part #": "FAB201824",
      "Fabric Name/Color": "JENNIE SNOW",
      Grade: "Premium C",
      "JL Upholstery": "JL Catalog - Crypton",
      "Solid or Pattern": "Solid",
      "Material Type": "Chenille",
      "Color Category": "Whites & Neutrals",
    },
    {
      "Part #": "FAB201815",
      "Fabric Name/Color": "MIZU MIST",
      Grade: "Premium C",
      "JL Upholstery": "JL Catalog - Crypton",
      "Solid or Pattern": "Solid",
      "Material Type": "Woven Texture",
      "Color Category": "Blues",
    },
    {
      "Part #": "FAB201816",
      "Fabric Name/Color": "MIZU PARCHMENT",
      Grade: "Premium C",
      "JL Upholstery": "JL Catalog - Crypton",
      "Solid or Pattern": "Solid",
      "Material Type": "Woven Texture",
      "Color Category": "Whites & Neutrals",
    },
    {
      "Part #": "FAB201817",
      "Fabric Name/Color": "MIZU QUARTZ",
      Grade: "Premium C",
      "JL Upholstery": "JL Catalog - Crypton",
      "Solid or Pattern": "Solid",
      "Material Type": "Woven Texture",
      "Color Category": "Whites & Neutrals",
    },
    {
      "Part #": "FAB201818",
      "Fabric Name/Color": "MIZU SUGAR",
      Grade: "Premium C",
      "JL Upholstery": "JL Catalog - Crypton",
      "Solid or Pattern": "Solid",
      "Material Type": "Woven Texture",
      "Color Category": "Whites & Neutrals",
    },
    {
      "Part #": "FAB201821",
      "Fabric Name/Color": "NOMAD CARAMEL",
      Grade: "Premium B",
      "JL Upholstery": "JL Catalog - Crypton",
      "Solid or Pattern": "Solid",
      "Material Type": "Woven Texture",
      "Color Category": "Browns",
    },
    {
      "Part #": "FAB201492",
      "Fabric Name/Color": "NOMAD CHARCOAL",
      Grade: "Premium B",
      "JL Upholstery": "JL Catalog - Crypton",
      "Solid or Pattern": "Solid",
      "Material Type": "Woven Texture",
      "Color Category": "Greys & Charcoal",
    },
    {
      "Part #": "FAB201820",
      "Fabric Name/Color": "NOMAD HEMP",
      Grade: "Premium B",
      "JL Upholstery": "JL Catalog - Crypton",
      "Solid or Pattern": "Solid",
      "Material Type": "Woven Texture",
      "Color Category": "Greens & Yellows",
    },
    {
      "Part #": "FAB201488",
      "Fabric Name/Color": "NOMAD SNOW",
      Grade: "Premium B",
      "JL Upholstery": "JL Catalog - Crypton",
      "Solid or Pattern": "Solid",
      "Material Type": "Woven Texture",
      "Color Category": "Whites & Neutrals",
    },
    {
      "Part #": "FAB201819",
      "Fabric Name/Color": "NOMAD STONE",
      Grade: "Premium B",
      "JL Upholstery": "JL Catalog - Crypton",
      "Solid or Pattern": "Solid",
      "Material Type": "Woven Texture",
      "Color Category": "Whites & Neutrals",
    },
    {
      "Part #": "FAB201829",
      "Fabric Name/Color": "SHAWCREST CHARCOAL",
      Grade: "Premium A",
      "JL Upholstery": "JL Catalog - Crypton",
      "Solid or Pattern": "Solid",
      "Material Type": "Chenille",
      "Color Category": "Greys & Charcoals",
    },
    {
      "Part #": "FAB201828",
      "Fabric Name/Color": "SHAWCREST FOG",
      Grade: "Premium A",
      "JL Upholstery": "JL Catalog - Crypton",
      "Solid or Pattern": "Solid",
      "Material Type": "Chenille",
      "Color Category": "Whites & Neutrals",
    },
    {
      "Part #": "FAB201826",
      "Fabric Name/Color": "SHAWCREST OYSTER",
      Grade: "Premium C",
      "JL Upholstery": "JL Catalog - Crypton",
      "Solid or Pattern": "Solid",
      "Material Type": "Chenille",
      "Color Category": "Whites & Neutrals",
    },
    {
      "Part #": "FAB201830",
      "Fabric Name/Color": "SHAWCREST TROUT",
      Grade: "Premium A",
      "JL Upholstery": "JL Catalog - Crypton",
      "Solid or Pattern": "Solid",
      "Material Type": "Chenille",
      "Color Category": "Greys & Charcoals",
    },
    {
      "Part #": "FAB201827",
      "Fabric Name/Color": "SHAWCREST WHEAT",
      Grade: "Premium A",
      "JL Upholstery": "JL Catalog - Crypton",
      "Solid or Pattern": "Solid",
      "Material Type": "Chenille",
      "Color Category": "Whites & Neutrals",
    },
    {
      "Part #": "FAB201822",
      "Fabric Name/Color": "WAYFARER FROST",
      Grade: "Premium B",
      "JL Upholstery": "JL Catalog - Crypton",
      "Solid or Pattern": "Solid",
      "Material Type": "Woven Texture",
      "Color Category": "Whites & Neutrals",
    },
    {
      "Part #": "FAB201823",
      "Fabric Name/Color": "WAYFARER SNOW",
      Grade: "Premium C",
      "JL Upholstery": "JL Catalog - Crypton",
      "Solid or Pattern": "Solid",
      "Material Type": "Woven Texture",
      "Color Category": "Whites & Neutrals",
    },
    {
      "Part #": "FAB201978",
      "Fabric Name/Color": "ADELAIDE JEANS",
      Grade: "Basic",
      "JL Upholstery": "JL Catalog",
      "Solid or Pattern": "Solid",
      "Material Type": "Woven Texture",
      "Color Category": "Blues",
    },
    {
      "Part #": "FAB201974",
      "Fabric Name/Color": "ANDREW EVERGLADE",
      Grade: "Basic",
      "JL Upholstery": "JL Catalog",
      "Solid or Pattern": "Solid",
      "Material Type": "Woven Texture",
      "Color Category": "Blues",
    },
    {
      "Part #": "FAB201976",
      "Fabric Name/Color": "DAVIS DENIM",
      Grade: "Accent & Pillow",
      "JL Upholstery": "JL Catalog",
      "Solid or Pattern": "Pattern",
      "Material Type": "Woven Texture",
      "Color Category": "Blues",
    },
    {
      "Part #": "FAB201977",
      "Fabric Name/Color": "EUAN GRAPHITE",
      Grade: "Accent & Pillow",
      "JL Upholstery": "JL Catalog",
      "Solid or Pattern": "Pattern",
      "Material Type": "Woven Texture",
      "Color Category": "Whites & Neutrals",
    },
    {
      "Part #": "FAB201973",
      "Fabric Name/Color": "GELLAR MOSS",
      Grade: "Basic",
      "JL Upholstery": "JL Catalog",
      "Solid or Pattern": "Solid",
      "Material Type": "Woven Texture",
      "Color Category": "Greens & Yellows",
    },
    {
      "Part #": "FAB201975",
      "Fabric Name/Color": "HOTSPRINGS SHERBERT",
      Grade: "Accent & Pillow",
      "JL Upholstery": "JL Catalog",
      "Solid or Pattern": "Pattern",
      "Material Type": "Print",
      "Color Category": "Pink, Red, & Orange",
    },
    {
      "Part #": "FAB201959",
      "Fabric Name/Color": "MONDAVI HEMP",
      Grade: "Accent & Pillow",
      "JL Upholstery": "JL Catalog",
      "Solid or Pattern": "Pattern",
      "Material Type": "Jacquard",
      "Color Category": "Greys & Charcoal",
    },
    {
      "Part #": "FAB201952",
      "Fabric Name/Color": "FRIZZLE SAGE",
      Grade: "Basic",
      "JL Upholstery": "JL Catalog",
      "Solid or Pattern": "Pattern",
      "Material Type": "Woven Texture",
      "Color Category": "Greens & Yellows",
    },
    {
      "Part #": "FAB201956",
      "Fabric Name/Color": "OTERO BIRCH",
      Grade: "Accent & Pillow",
      "JL Upholstery": "JL Catalog",
      "Solid or Pattern": "Pattern",
      "Material Type": "Jacquard",
      "Color Category": "Whites & Neutrals",
    },
    {
      "Part #": "FAB201971",
      "Fabric Name/Color": "THRILLER AMBER",
      Grade: "Basic",
      "JL Upholstery": "JL Catalog",
      "Solid or Pattern": "Solid",
      "Material Type": "Chenille",
      "Color Category": "Browns",
    },
  ],
  "DropDown-IGNORE": [
    {
      Grade: "Basic",
      "Fabric Selection ": "JL Upholstery",
      Thread: "Black",
      "JL item no.": "SEW100021",
      "Solid or Pattern": "Solid",
      "Jonathan Louis ": "All JL Items",
      "JL Design Lab": "All JLDL Items",
      "Just Live™ Performance Fabrics": "Bleach Cleanable",
      "Type of Fabric": "Canvas/ Cotton",
      "Color Family": "Blacks & Purples",
      "Yes(Y) or No(N)": "Yes",
    },
    {
      Grade: "Premium A",
      "Fabric Selection ": "JL Design Lab Exclusive",
      Thread: "Crimson",
      "JL item no.": "SEW100022",
      "Solid or Pattern": "Pattern",
      "Jonathan Louis ": "JL Accessories",
      "JL Design Lab": "All Sofa POP",
      "Just Live™ Performance Fabrics": "Durable 30,000 DR",
      "Type of Fabric": "Chenille",
      "Color Family": "Blues",
      "Yes(Y) or No(N)": "No",
    },
    {
      Grade: "Premium B ",
      "Fabric Selection ": "Macy's Exclusive",
      Thread: "Dark Brown",
      "JL item no.": "SEW100023",
      "Jonathan Louis ": "JL Bedroom",
      "JL Design Lab": "JLDL Bedroom",
      "Just Live™ Performance Fabrics": "Fade Resistant",
      "Type of Fabric": "Linen Look",
      "Color Family": "Browns",
    },
    {
      Grade: "Premium C ",
      "Fabric Selection ": "Living Spaces Exclusive",
      Thread: "Midnight Grey",
      "JL item no.": "SEW100024",
      "Jonathan Louis ": "JL Stationary",
      "JL Design Lab": "JLDL Dining",
      "Just Live™ Performance Fabrics": "Moisture Repellent",
      "Type of Fabric": "Velvet",
      "Color Family": "Greens & Yellows",
    },
    {
      Grade: "Accent/Pillow ",
      "Fabric Selection ": "Living Spaces- N&J Exclusive",
      Thread: "Sand",
      "JL item no.": "SEW100058",
      "Jonathan Louis ": "JL Toss Pillows",
      "JL Design Lab": "JLDL Living Room",
      "Just Live™ Performance Fabrics": "Soap Cleanable",
      "Type of Fabric": "Woven Texture",
      "Color Family": "Greys & Charcoal",
    },
    {
      Grade: "Top Grain Leather",
      "Fabric Selection ": "Raymour & Flanigan Exclusive",
      Thread: "White",
      "JL item no.": "SEW100026",
      "Jonathan Louis ": "Select JL Accents",
      "JL Design Lab": "JLDL Sofa & Sectional",
      "Just Live™ Performance Fabrics": "Stain Resistant",
      "Type of Fabric": "Faux Fur",
      "Color Family": "Pink, Red, & Orange",
    },
    {
      Grade: "Bonded Leather",
      "Fabric Selection ": "Interline Exclusive",
      "Jonathan Louis ": "Select JL Bedroom",
      "JL Design Lab": "Sofa POP Accents",
      "Type of Fabric": "Polyurethane",
      "Color Family": "Whites & Neutrals",
    },
    {
      Grade: "Restricted Basic",
      "Fabric Selection ": "Haverty's Exclusive",
      "Jonathan Louis ": "Select JL Stationary",
      "JL Design Lab": "Sofa POP Pillows",
      "Type of Fabric": "Jacquard",
    },
    {
      Grade: "Restricted Premium A",
      "Fabric Selection ": "Jordans Exclusive",
      "Type of Fabric": "Geometric",
    },
    {
      Grade: "Restricted Premium B",
      "Fabric Selection ": "Rooms 2 Go Exclusive",
      "Type of Fabric": "Print",
    },
    {
      Grade: "Restricted Premium C",
      "Fabric Selection ": "Z Gallerie Exclusive",
      "Type of Fabric": "Leather",
    },
    {
      Grade: "Restricted Accent/Pillow",
      "Fabric Selection ": "RC Willey Exclusive",
    },
    {
      Grade: "Accent/Pillow & Premium A",
      "Fabric Selection ": "CSWO Exclusive",
    },
    {
      Grade: "Accent/Pillow & Premium B",
      "Fabric Selection ": "CB2",
    },
    {
      Grade: "Accent/Pillow & Premium C",
    },
    {
      Grade: "Accent/Pillow & Restricted ",
    },
    {
      Grade: "SUNBRELLA- Accent C",
    },
    {
      Grade: "SUNBRELLA-BASIC",
    },
    {
      Grade: "SUNBRELLA-PREMIUM A",
    },
    {
      Grade: "SUNBRELLA-PREMIUM B",
    },
    {
      Grade: "SUNBRELLA-PREMIUM C",
    },
    {
      Grade: "SUNBRELLA- Accent A",
    },
    {
      Grade: "SUNBRELLA- Accent B",
    },
  ],
};

export default filterRules;
